/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
// @ts-ignore
// prettier-ignore
import type { RequestConfig,RequestFunctionRestArgs } from 'yapi-to-typescript';
import {
  Method,
  prepare,
  QueryStringArrayFormat,
  RequestBodyType,
  ResponseBodyType,
} from 'yapi-to-typescript';
// @ts-ignore
import request from '../ajax/index';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://yapi.cai-inc.com/mock/3705' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = '' as any;
const dataKey_0_0_0_0 = 'data' as any;

/**
 * 接口 [下拉列表查询↗](http://yapi.cai-inc.com/project/3705/interface/api/309058) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/list`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemListPostRequest {
  /**
   * 单据类型
   */
  expenseFormType: 1 | 2 | 3 | 6 | 4 | 11 | 15;
  /**
   * 费用分类
   */
  feeTypeCode:
    | '20'
    | '10'
    | '30'
    | '40'
    | '50'
    | '60'
    | '70'
    | '80'
    | '90'
    | '100'
    | '110'
    | '120'
    | '130'
    | '140'
    | '160'
    | '170'
    | '180'
    | '190';
  /**
   * 费用项
   */
  feeItemCode:
    | '2001'
    | '2002'
    | '2003'
    | '2007'
    | '1001'
    | '3001'
    | '4001'
    | '5001'
    | '6001'
    | '7001'
    | '8001'
    | '9001'
    | '10001'
    | '11001'
    | '12001'
    | '13001'
    | '14001'
    | '16001'
    | '17001'
    | '18001'
    | '19001';
}

/**
 * 接口 [下拉列表查询↗](http://yapi.cai-inc.com/project/3705/interface/api/309058) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/list`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 费用项规则编码
     */
    itemConfigCode?: string;
    /**
     * 费用项规则名称
     */
    itemConfigName?: string;
    /**
     * 单据类型
     */
    expenseFormType?:
      | 1
      | 1
      | 1
      | 1
      | 1
      | 1
      | 1
      | 1
      | 2
      | 2
      | 2
      | 3
      | 3
      | 3
      | 3
      | 3
      | 6
      | 4
      | 11
      | 11
      | 15;
    /**
     * 单据类型名称
     */
    expenseFormTypeName?:
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '会议申请、报销单'
      | '会议申请、报销单'
      | '会议申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '公务接待报销单'
      | '办公用品采购申请单'
      | '办公家具设备购置申请单'
      | '办公家具设备购置申请单'
      | '夜餐费发放单';
    /**
     * 费用分类编码
     */
    feeType?:
      | '20'
      | '20'
      | '20'
      | '20'
      | '10'
      | '30'
      | '40'
      | '50'
      | '60'
      | '70'
      | '80'
      | '90'
      | '100'
      | '110'
      | '120'
      | '130'
      | '140'
      | '160'
      | '170'
      | '180'
      | '190';
    /**
     * 费用分类名称
     */
    feeTypeName?:
      | '交通费'
      | '交通费'
      | '交通费'
      | '交通费'
      | '住宿费'
      | '伙食补贴'
      | '公杂补贴'
      | '短途包干'
      | '住宿费'
      | '伙食费'
      | '其他'
      | '住宿费'
      | '伙食费'
      | '场地、资料、交通类'
      | '师资类'
      | '其他'
      | '工作餐费'
      | '默认分类'
      | '家具'
      | '设备'
      | '夜餐费';
    /**
     * 费用项编码
     */
    feeItemCode?:
      | '2001'
      | '2002'
      | '2003'
      | '2007'
      | '1001'
      | '3001'
      | '4001'
      | '5001'
      | '6001'
      | '7001'
      | '8001'
      | '9001'
      | '10001'
      | '11001'
      | '12001'
      | '13001'
      | '14001'
      | '16001'
      | '17001'
      | '18001'
      | '19001';
    /**
     * 费用项名称
     */
    feeItemName?: string;
    /**
     * 对应的规则引擎的策略编码
     */
    strategyCode?: string;
    /**
     * 控制等级编码
     */
    feeControlLevel?: number;
    /**
     * 控制等级编码
     */
    feeControlLevelName?: string;
    /**
     * 是否需要填超标原因编码
     */
    feeReasonNeed?: number;
    /**
     * 是否需要填超标原因编码
     */
    feeReasonNeedName?: string;
    /**
     * 状态 0禁用 1启用
     */
    useStatus?: number;
    /**
     * 状态展示字段
     */
    useStatusName?: string;
    /**
     * 更新人名称
     */
    updatedByName?: string;
    /**
     * 更新时间
     */
    rModifiedTime?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [下拉列表查询↗](http://yapi.cai-inc.com/project/3705/interface/api/309058) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/list`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [下拉列表查询↗](http://yapi.cai-inc.com/project/3705/interface/api/309058) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/list`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
const zlbCostControlFeeItemListPostRequestConfig: ZlbCostControlFeeItemListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [下拉列表查询↗](http://yapi.cai-inc.com/project/3705/interface/api/309058) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/list`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemListPost = /*#__PURE__*/ (
  requestData: ZlbCostControlFeeItemListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemListPostResponse>(
    prepare(zlbCostControlFeeItemListPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemListPost.requestConfig = zlbCostControlFeeItemListPostRequestConfig;

/**
 * 接口 [保存\/编辑费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309066) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/save`
 * @更新时间 `2024-09-09 16:00:55`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemSavePostRequest {
  /**
   * 费用项规则编号
   */
  itemConfigCode?: string;
  /**
   * 费用项规则名称
   */
  itemConfigName: string;
  /**
   * 报销单类型
   */
  expenseFormType: 1 | 2 | 3 | 6 | 4 | 11 | 15;
  /**
   * 费用类型
   */
  feeTypeCode:
    | '20'
    | '10'
    | '30'
    | '40'
    | '50'
    | '60'
    | '70'
    | '80'
    | '90'
    | '100'
    | '110'
    | '120'
    | '130'
    | '140'
    | '160'
    | '170'
    | '180'
    | '190';
  /**
   * 费用项编码
   */
  feeItemCode:
    | '2001'
    | '2002'
    | '2003'
    | '2007'
    | '1001'
    | '3001'
    | '4001'
    | '5001'
    | '6001'
    | '7001'
    | '8001'
    | '9001'
    | '10001'
    | '11001'
    | '12001'
    | '13001'
    | '14001'
    | '16001'
    | '17001'
    | '18001'
    | '19001';
  /**
   * 控制等级:  1弱控 2提示 3强控
   */
  feeControlLevel?: 1 | 2 | 3;
  /**
   * 是否需要填写超标原因编码： 0不用 1需要
   */
  feeReasonNeed?: 1 | 0;
  /**
   * 启用状态：0停用 1启用
   */
  useStatus: number;
  /**
   * 备注
   */
  feeRemark?: string;
  /**
   * 费用项扩展字段
   */
  feeItemConfigExtendData: {
    /**
     * 交通费用项拓展字段;列表内职级不能有交叉;列表内只能有一个default
     */
    travelExtendDataDTOS?: {
      /**
       * 职级组编号
       */
      rankGroupCode: string;
      /**
       * 职级组名称
       */
      rankGroupName: string;
      /**
       * 配置结果
       */
      result: {
        /**
         * 交通工具levelKey
         */
        code: string;
        /**
         * 交通工具level描述
         */
        desc: string;
      }[];
    }[];
    /**
     * 交通费自驾
     */
    travelDriveExtendDataDTO?: {
      /**
       * 金额合计
       */
      amount: number;
    };
    /**
     * 住宿费用项拓展字段
     */
    hotelExtendDataDTOS?: {
      /**
       * 一级区划编码
       */
      firstArea: {
        /**
         * 区划名称
         */
        placeName: string;
        /**
         * 区划编码
         */
        placeCode: string;
        /**
         * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
         */
        placeLevel?: number;
        /**
         * 全路径区划编码
         */
        pathCodeChain: string;
      };
      /**
       * 普通详细信息
       */
      normalData: {
        /**
         * 时间跨度其他 0否 1是
         */
        isDefault: number;
        /**
         * 目的地,默认配置没有
         */
        destination?: {
          /**
           * 区划名称
           */
          placeName: string;
          /**
           * 区划编码
           */
          placeCode: string;
          /**
           * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
           */
          placeLevel?: number;
          /**
           * 全路径区划编码
           */
          pathCodeChain: string;
        }[];
        /**
         * 用户职级
         */
        rank: {
          /**
           * 因子值
           */
          value?: string;
          /**
           * 因子名称
           */
          name?: string;
          /**
           * 费用标准 for 住宿费
           */
          amount?: number;
        }[];
        /**
         * 前端对接需要
         */
        uuid?: string;
        /**
         * 时间范围-开始（特殊规则）
         */
        startDate?: string;
        /**
         * 时间范围-结束（特殊规则）
         */
        endDate?: string;
      }[];
      /**
       * 特殊详细信息
       */
      specialData?: {
        /**
         * 时间跨度其他 0否 1是
         */
        isDefault: number;
        /**
         * 目的地,默认配置没有
         */
        destination?: {
          /**
           * 区划名称
           */
          placeName: string;
          /**
           * 区划编码
           */
          placeCode: string;
          /**
           * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
           */
          placeLevel?: number;
          /**
           * 全路径区划编码
           */
          pathCodeChain: string;
        }[];
        /**
         * 用户职级
         */
        rank: {
          /**
           * 因子值
           */
          value?: string;
          /**
           * 因子名称
           */
          name?: string;
          /**
           * 费用标准 for 住宿费
           */
          amount?: number;
        }[];
        /**
         * 前端对接需要
         */
        uuid?: string;
        /**
         * 时间范围-开始（特殊规则）
         */
        startDate?: string;
        /**
         * 时间范围-结束（特殊规则）
         */
        endDate?: string;
      }[];
    }[];
    /**
     * 伙食费用项拓展字段
     */
    foodExtendDataDTOS?: {
      /**
       * 差旅类型
       */
      travelType: number;
      /**
       * 去除双休日：true-不计算双休日
       */
      removeWeekend?: boolean;
      /**
       * 基本规则
       */
      normalData: {
        /**
         * 前端唯一标识
         */
        uuid?: string;
        /**
         * 是否默认（其他）0否1是 基本规则才能是1
         */
        isDefault: number;
        /**
         * 出发地（特殊规则）
         */
        departure?: {
          /**
           * 区划名称
           */
          placeName: string;
          /**
           * 区划编码
           */
          placeCode: string;
          /**
           * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
           */
          placeLevel?: number;
          /**
           * 全路径区划编码
           */
          pathCodeChain: string;
        }[];
        /**
         * 目的地
         */
        destination?: {
          /**
           * 区划名称
           */
          placeName: string;
          /**
           * 区划编码
           */
          placeCode: string;
          /**
           * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
           */
          placeLevel?: number;
          /**
           * 全路径区划编码
           */
          pathCodeChain: string;
        }[];
        /**
         * 时间跨度
         */
        dateConditionDTOS: {
          /**
           * 前端唯一标识
           */
          uuid?: string;
          /**
           * 时间跨度开始天数
           */
          startDays?: number;
          /**
           * 时间跨度结束天数
           */
          endDays?: number;
          /**
           * 区间金额（伙食）
           */
          amount: number;
          /**
           * 时间跨度其他 0否 1是
           */
          isDefault: number;
        }[];
        /**
         * 是否凭票报销：1是0否
         */
        isUseInvoice?: number;
        /**
         * 常住地编码（一,二,三级）
         */
        residence?: string;
        /**
         * 常住地名称（一,二,三级）
         * 浙江省,杭州市,西湖区
         */
        residenceName?: string;
      }[];
      /**
       * 特殊规则
       */
      specialData?: {
        /**
         * 前端唯一标识
         */
        uuid?: string;
        /**
         * 是否默认（其他）0否1是 基本规则才能是1
         */
        isDefault: number;
        /**
         * 出发地（特殊规则）
         */
        departure?: {
          /**
           * 区划名称
           */
          placeName: string;
          /**
           * 区划编码
           */
          placeCode: string;
          /**
           * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
           */
          placeLevel?: number;
          /**
           * 全路径区划编码
           */
          pathCodeChain: string;
        }[];
        /**
         * 目的地
         */
        destination?: {
          /**
           * 区划名称
           */
          placeName: string;
          /**
           * 区划编码
           */
          placeCode: string;
          /**
           * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
           */
          placeLevel?: number;
          /**
           * 全路径区划编码
           */
          pathCodeChain: string;
        }[];
        /**
         * 时间跨度
         */
        dateConditionDTOS: {
          /**
           * 前端唯一标识
           */
          uuid?: string;
          /**
           * 时间跨度开始天数
           */
          startDays?: number;
          /**
           * 时间跨度结束天数
           */
          endDays?: number;
          /**
           * 区间金额（伙食）
           */
          amount: number;
          /**
           * 时间跨度其他 0否 1是
           */
          isDefault: number;
        }[];
        /**
         * 是否凭票报销：1是0否
         */
        isUseInvoice?: number;
        /**
         * 常住地编码（一,二,三级）
         */
        residence?: string;
        /**
         * 常住地名称（一,二,三级）
         * 浙江省,杭州市,西湖区
         */
        residenceName?: string;
      }[];
    }[];
    /**
     * 公杂费用项拓展字段
     */
    miscellaneousExtendDataDTOS?: {
      /**
       * 差旅类型
       */
      travelType: number;
      /**
       * 基本规则
       */
      normalData: {
        /**
         * 前端唯一标识
         */
        uuid?: string;
        /**
         * 是否默认（其他）0否1是 基本规则才能是1
         */
        isDefault: number;
        /**
         * 出发地（特殊规则）
         */
        departure?: {
          /**
           * 区划名称
           */
          placeName: string;
          /**
           * 区划编码
           */
          placeCode: string;
          /**
           * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
           */
          placeLevel?: number;
          /**
           * 全路径区划编码
           */
          pathCodeChain: string;
        }[];
        /**
         * 目的地
         */
        destination?: {
          /**
           * 区划名称
           */
          placeName: string;
          /**
           * 区划编码
           */
          placeCode: string;
          /**
           * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
           */
          placeLevel?: number;
          /**
           * 全路径区划编码
           */
          pathCodeChain: string;
        }[];
        /**
         * 时间跨度
         */
        dateConditionDTOS: {
          /**
           * 前端唯一标识
           */
          uuid?: string;
          /**
           * 时间跨度开始天数
           */
          startDays?: number;
          /**
           * 时间跨度结束天数
           */
          endDays?: number;
          /**
           * 区间金额（派车公杂） 外派可能为空
           */
          sendCarAmount?: number;
          /**
           * 区间金额（不派车公杂）
           */
          notSendCarAmount: number;
          /**
           * 时间跨度其他 0否 1是
           */
          isDefault: number;
          /**
           * 外派每月补贴次数
           */
          allowanceTimes?: number;
          /**
           * 外派残月时间跨度
           */
          expatriateDateConditionList?: {
            /**
             * 时间跨度开始天数
             */
            startDays?: number;
            /**
             * 时间跨度结束天数
             */
            endDays?: number;
            /**
             * 外派每月补贴次数
             */
            allowanceTimes: number;
            /**
             * 时间跨度其他 0否 1是
             */
            isDefault: number;
            /**
             * 前端唯一标识
             */
            uuid?: string;
          }[];
        }[];
      }[];
      /**
       * 特殊规则
       */
      specialData?: {
        /**
         * 前端唯一标识
         */
        uuid?: string;
        /**
         * 是否默认（其他）0否1是 基本规则才能是1
         */
        isDefault: number;
        /**
         * 出发地（特殊规则）
         */
        departure?: {
          /**
           * 区划名称
           */
          placeName: string;
          /**
           * 区划编码
           */
          placeCode: string;
          /**
           * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
           */
          placeLevel?: number;
          /**
           * 全路径区划编码
           */
          pathCodeChain: string;
        }[];
        /**
         * 目的地
         */
        destination?: {
          /**
           * 区划名称
           */
          placeName: string;
          /**
           * 区划编码
           */
          placeCode: string;
          /**
           * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
           */
          placeLevel?: number;
          /**
           * 全路径区划编码
           */
          pathCodeChain: string;
        }[];
        /**
         * 时间跨度
         */
        dateConditionDTOS: {
          /**
           * 前端唯一标识
           */
          uuid?: string;
          /**
           * 时间跨度开始天数
           */
          startDays?: number;
          /**
           * 时间跨度结束天数
           */
          endDays?: number;
          /**
           * 区间金额（派车公杂） 外派可能为空
           */
          sendCarAmount?: number;
          /**
           * 区间金额（不派车公杂）
           */
          notSendCarAmount: number;
          /**
           * 时间跨度其他 0否 1是
           */
          isDefault: number;
          /**
           * 外派每月补贴次数
           */
          allowanceTimes?: number;
          /**
           * 外派残月时间跨度
           */
          expatriateDateConditionList?: {
            /**
             * 时间跨度开始天数
             */
            startDays?: number;
            /**
             * 时间跨度结束天数
             */
            endDays?: number;
            /**
             * 外派每月补贴次数
             */
            allowanceTimes: number;
            /**
             * 时间跨度其他 0否 1是
             */
            isDefault: number;
            /**
             * 前端唯一标识
             */
            uuid?: string;
          }[];
        }[];
      }[];
    }[];
    /**
     * 短途包干费用项拓展字段
     */
    shortDistanceExtendDataDTOS?: {
      /**
       * 一级区划编码
       */
      firstArea: {
        /**
         * 区划名称
         */
        placeName: string;
        /**
         * 区划编码
         */
        placeCode: string;
        /**
         * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
         */
        placeLevel?: number;
        /**
         * 全路径区划编码
         */
        pathCodeChain: string;
      };
      /**
       * 表格内容
       */
      matrixData?: {
        /**
         * 出发地
         */
        departure: {
          /**
           * 区划名称
           */
          placeName: string;
          /**
           * 区划编码
           */
          placeCode: string;
          /**
           * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
           */
          placeLevel?: number;
          /**
           * 全路径区划编码
           */
          pathCodeChain: string;
        };
        /**
         * 目的地和金额列表
         */
        destination: {
          /**
           * 区划名称
           */
          placeName: string;
          /**
           * 区划编码
           */
          placeCode: string;
          /**
           * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
           */
          placeLevel?: number;
          /**
           * 全路径区划编码
           */
          pathCodeChain: string;
          /**
           * 金额
           */
          amount?: number;
          /**
           * 往返金额
           */
          doubleRouteAmount?: number;
        }[];
      }[];
      /**
       * 是否往返配置
       * true：开启
       */
      doubleRoute?: boolean;
      /**
       * 前端字段快速回显
       */
      quickFill?: number;
    }[];
    /**
     * 会议-住宿费
     */
    meetingHotelExtendDataDTOS?: {
      /**
       * 会议级别
       */
      levelValue: number;
      /**
       * 会议级别名称
       */
      levelName: string;
      /**
       * 金额
       */
      amount: number;
    }[];
    /**
     * 会议-伙食费
     */
    meetingFoodExtendDataDTOS?: {
      /**
       * 会议级别
       */
      levelValue: number;
      /**
       * 会议级别名称
       */
      levelName: string;
      /**
       * 金额
       */
      amount: number;
    }[];
    /**
     * 会议-其他
     */
    meetingOtherExtendDataDTOS?: {
      /**
       * 会议级别
       */
      levelValue: number;
      /**
       * 会议级别名称
       */
      levelName: string;
      /**
       * 金额
       */
      amount: number;
    }[];
    /**
     * 培训-住宿费
     */
    trainingHotelExtendDataDTOS?: {
      /**
       * 培训级别
       */
      levelValue: number;
      /**
       * 培训级别名称
       */
      levelName: string;
      /**
       * 金额详情
       */
      data: {
        uuid?: string;
        /**
         * 时间跨度开始天数
         */
        startDays?: number;
        /**
         * 时间跨度结束天数
         */
        endDays?: number;
        /**
         * 金额
         */
        amount: number;
        /**
         * 是否默认（其他）
         */
        isDefault: number;
      }[];
    }[];
    /**
     * 培训-伙食费
     */
    trainingFoodExtendDataDTOS?: {
      /**
       * 培训级别
       */
      levelValue: number;
      /**
       * 培训级别名称
       */
      levelName: string;
      /**
       * 金额详情
       */
      data: {
        uuid?: string;
        /**
         * 时间跨度开始天数
         */
        startDays?: number;
        /**
         * 时间跨度结束天数
         */
        endDays?: number;
        /**
         * 金额
         */
        amount: number;
        /**
         * 是否默认（其他）
         */
        isDefault: number;
      }[];
    }[];
    /**
     * 培训-场地、资料、交通
     */
    trainingIncidentalExtendDataDTOS?: {
      /**
       * 培训级别
       */
      levelValue: number;
      /**
       * 培训级别名称
       */
      levelName: string;
      /**
       * 金额详情
       */
      data: {
        uuid?: string;
        /**
         * 时间跨度开始天数
         */
        startDays?: number;
        /**
         * 时间跨度结束天数
         */
        endDays?: number;
        /**
         * 金额
         */
        amount: number;
        /**
         * 是否默认（其他）
         */
        isDefault: number;
      }[];
    }[];
    /**
     * 培训-讲师费
     */
    trainingTeachExtendDataDTOS?: {
      /**
       * 讲师级别
       */
      levelValue: number;
      /**
       * 讲师级别名称
       */
      levelName: string;
      /**
       * 金额
       */
      amount: number;
    }[];
    /**
     * 培训-其他
     */
    trainingOtherExtendDataDTOS?: {
      /**
       * 培训级别
       */
      levelValue: number;
      /**
       * 培训级别名称
       */
      levelName: string;
      /**
       * 金额详情
       */
      data: {
        uuid?: string;
        /**
         * 时间跨度开始天数
         */
        startDays?: number;
        /**
         * 时间跨度结束天数
         */
        endDays?: number;
        /**
         * 金额
         */
        amount: number;
        /**
         * 是否默认（其他）
         */
        isDefault: number;
      }[];
    }[];
    /**
     * 公务接待-工作餐
     */
    receptionMealExtendDataDTOS?: {
      /**
       * 职级组名称
       */
      rankGroupCode: string;
      /**
       * 职级组名称
       */
      rankGroupName: string;
      /**
       * 金额
       */
      amount: number;
    }[];
    /**
     * 公务接待-其他
     */
    receptionOtherExtendDataDTOS?: {
      /**
       * 职级组名称
       */
      rankGroupCode: string;
      /**
       * 职级组名称
       */
      rankGroupName: string;
      /**
       * 金额
       */
      amount: number;
    }[];
    /**
     * 通用采购申请单-金额合计
     */
    purchaseExtendDataDTO?: {
      /**
       * 金额合计
       */
      amount: number;
    };
    /**
     * 办公设备家具购置申请单-家具
     */
    furnitureExtendDataDTOS?: {
      /**
       * 家具code
       */
      code: string;
      /**
       * 家具名称
       */
      name: string;
      /**
       * 详细数据
       */
      data: {
        /**
         * 职级组编号
         */
        rankGroupCode: string;
        /**
         * 职级组名称
         */
        rankGroupName: string;
        /**
         * 金额
         */
        amount: number;
      }[];
    }[];
    /**
     * 办公设备家具购置申请单-设备
     */
    equipmentExtendDataDTOS?: {
      /**
       * 设备code
       */
      code: string;
      /**
       * 设备名称
       */
      name: string;
      /**
       * 金额
       */
      amount: number;
    }[];
    /**
     * 夜餐费-夜餐费
     */
    overtimeExtendDataDTOS?: {
      /**
       * 前端唯一键
       */
      uuid?: string;
      /**
       * 0工作日 1休息日
       */
      dateType?: number;
      /**
       * 开始时间，只取时间，不管日期
       */
      startTime: string;
      /**
       * 结束时间，只取时间，不管日期
       */
      endTime: string;
      /**
       * 补贴金额,单位分
       */
      amount: number;
      /**
       * 加班时间和补贴次数
       */
      hoursAndTimesList: {
        /**
         * 前端唯一键
         */
        uuid?: string;
        /**
         * 连续加班时间
         */
        hours: number;
        /**
         * 补贴次数
         */
        times: number;
      }[];
    }[];
  };
}

/**
 * 接口 [保存\/编辑费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309066) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/save`
 * @更新时间 `2024-09-09 16:00:55`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemSavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 数据校验失败行下标（从0开始）
     */
    rowIndex?: number;
    /**
     * 失败信息
     */
    message?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存\/编辑费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309066) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/save`
 * @更新时间 `2024-09-09 16:00:55`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存\/编辑费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309066) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/save`
 * @更新时间 `2024-09-09 16:00:55`
 * @项目ID 3705
 */
const zlbCostControlFeeItemSavePostRequestConfig: ZlbCostControlFeeItemSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存\/编辑费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309066) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/save`
 * @更新时间 `2024-09-09 16:00:55`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemSavePost = /*#__PURE__*/ (
  requestData: ZlbCostControlFeeItemSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemSavePostResponse>(
    prepare(zlbCostControlFeeItemSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemSavePost.requestConfig = zlbCostControlFeeItemSavePostRequestConfig;

/**
 * 接口 [查询费用项规则详情↗](http://yapi.cai-inc.com/project/3705/interface/api/309074) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/query/{itemConfigCode}`
 * @更新时间 `2024-09-09 16:00:55`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemQueryItemConfigCodeGetRequest {
  itemConfigCode: string;
}

/**
 * 接口 [查询费用项规则详情↗](http://yapi.cai-inc.com/project/3705/interface/api/309074) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/query/{itemConfigCode}`
 * @更新时间 `2024-09-09 16:00:55`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemQueryItemConfigCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 费用项配置编码
     */
    itemConfigCode?: string;
    /**
     * 费用项名称
     */
    itemConfigName?: string;
    /**
     * 报销单类型
     */
    expenseFormType?: 1 | 2 | 3 | 6 | 4 | 11 | 15;
    /**
     * 报销单类型前端展示字段
     */
    expenseFormTypeName?:
      | '差旅报销单'
      | '会议申请、报销单'
      | '培训申请、报销单'
      | '公务接待报销单'
      | '办公用品采购申请单'
      | '办公家具设备购置申请单'
      | '夜餐费发放单';
    /**
     * 费用类型
     */
    feeTypeCode?:
      | '20'
      | '10'
      | '30'
      | '40'
      | '50'
      | '60'
      | '70'
      | '80'
      | '90'
      | '100'
      | '110'
      | '120'
      | '130'
      | '140'
      | '160'
      | '170'
      | '180'
      | '190';
    /**
     * 费用类型名称
     */
    feeTypeName?:
      | '交通费'
      | '住宿费'
      | '伙食补贴'
      | '公杂补贴'
      | '短途包干'
      | '伙食费'
      | '其他'
      | '场地、资料、交通类'
      | '师资类'
      | '工作餐费'
      | '默认分类'
      | '家具'
      | '设备'
      | '夜餐费';
    /**
     * 费用项code
     */
    feeItemCode?:
      | '2001'
      | '2002'
      | '2003'
      | '2007'
      | '1001'
      | '3001'
      | '4001'
      | '5001'
      | '6001'
      | '7001'
      | '8001'
      | '9001'
      | '10001'
      | '11001'
      | '12001'
      | '13001'
      | '14001'
      | '16001'
      | '17001'
      | '18001'
      | '19001';
    /**
     * 费用项名称
     */
    feeItemName?:
      | '火车'
      | '飞机'
      | '轮船'
      | '自驾'
      | '住宿'
      | '伙食补贴'
      | '公杂补贴'
      | '短途包干'
      | '住宿费'
      | '伙食费'
      | '其他'
      | '场地、资料、交通类'
      | '讲课费'
      | '工作餐费'
      | '金额合计'
      | '家具'
      | '设备'
      | '夜餐费';
    /**
     * 对应的规则引擎的策略编码
     */
    strategyCode?: string;
    /**
     * 控制等级编码
     */
    feeControlLevel?: number;
    /**
     * 控制等级编码
     */
    feeControlLevelName?: string;
    /**
     * 是否需要填超标原因编码
     */
    feeReasonNeed?: number;
    /**
     * 是否需要填超标原因编码
     */
    feeReasonNeedName?: string;
    /**
     * 启用状态：1停用 2启用
     */
    useStatus?: number;
    /**
     * 启用状态：1停用 2启用
     */
    useStatusName?: string;
    /**
     * 备注
     */
    feeRemark?: string;
    /**
     * 费用项扩展字段
     */
    feeItemConfigExtendData?: {
      /**
       * 交通费用项拓展字段;列表内职级不能有交叉;列表内只能有一个default
       */
      travelExtendDataDTOS?: {
        /**
         * 职级组编号
         */
        rankGroupCode: string;
        /**
         * 职级组名称
         */
        rankGroupName: string;
        /**
         * 配置结果
         */
        result: {
          /**
           * 交通工具levelKey
           */
          code: string;
          /**
           * 交通工具level描述
           */
          desc: string;
        }[];
      }[];
      /**
       * 交通费自驾
       */
      travelDriveExtendDataDTO?: {
        /**
         * 金额合计
         */
        amount: number;
      };
      /**
       * 住宿费用项拓展字段
       */
      hotelExtendDataDTOS?: {
        /**
         * 一级区划编码
         */
        firstArea: {
          /**
           * 区划名称
           */
          placeName: string;
          /**
           * 区划编码
           */
          placeCode: string;
          /**
           * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
           */
          placeLevel?: number;
          /**
           * 全路径区划编码
           */
          pathCodeChain: string;
        };
        /**
         * 普通详细信息
         */
        normalData: {
          /**
           * 时间跨度其他 0否 1是
           */
          isDefault: number;
          /**
           * 目的地,默认配置没有
           */
          destination?: {
            /**
             * 区划名称
             */
            placeName: string;
            /**
             * 区划编码
             */
            placeCode: string;
            /**
             * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
             */
            placeLevel?: number;
            /**
             * 全路径区划编码
             */
            pathCodeChain: string;
          }[];
          /**
           * 用户职级
           */
          rank: {
            /**
             * 因子值
             */
            value?: string;
            /**
             * 因子名称
             */
            name?: string;
            /**
             * 费用标准 for 住宿费
             */
            amount?: number;
          }[];
          /**
           * 前端对接需要
           */
          uuid?: string;
          /**
           * 时间范围-开始（特殊规则）
           */
          startDate?: string;
          /**
           * 时间范围-结束（特殊规则）
           */
          endDate?: string;
        }[];
        /**
         * 特殊详细信息
         */
        specialData?: {
          /**
           * 时间跨度其他 0否 1是
           */
          isDefault: number;
          /**
           * 目的地,默认配置没有
           */
          destination?: {
            /**
             * 区划名称
             */
            placeName: string;
            /**
             * 区划编码
             */
            placeCode: string;
            /**
             * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
             */
            placeLevel?: number;
            /**
             * 全路径区划编码
             */
            pathCodeChain: string;
          }[];
          /**
           * 用户职级
           */
          rank: {
            /**
             * 因子值
             */
            value?: string;
            /**
             * 因子名称
             */
            name?: string;
            /**
             * 费用标准 for 住宿费
             */
            amount?: number;
          }[];
          /**
           * 前端对接需要
           */
          uuid?: string;
          /**
           * 时间范围-开始（特殊规则）
           */
          startDate?: string;
          /**
           * 时间范围-结束（特殊规则）
           */
          endDate?: string;
        }[];
      }[];
      /**
       * 伙食费用项拓展字段
       */
      foodExtendDataDTOS?: {
        /**
         * 差旅类型
         */
        travelType: number;
        /**
         * 去除双休日：true-不计算双休日
         */
        removeWeekend?: boolean;
        /**
         * 基本规则
         */
        normalData: {
          /**
           * 前端唯一标识
           */
          uuid?: string;
          /**
           * 是否默认（其他）0否1是 基本规则才能是1
           */
          isDefault: number;
          /**
           * 出发地（特殊规则）
           */
          departure?: {
            /**
             * 区划名称
             */
            placeName: string;
            /**
             * 区划编码
             */
            placeCode: string;
            /**
             * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
             */
            placeLevel?: number;
            /**
             * 全路径区划编码
             */
            pathCodeChain: string;
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 区划名称
             */
            placeName: string;
            /**
             * 区划编码
             */
            placeCode: string;
            /**
             * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
             */
            placeLevel?: number;
            /**
             * 全路径区划编码
             */
            pathCodeChain: string;
          }[];
          /**
           * 时间跨度
           */
          dateConditionDTOS: {
            /**
             * 前端唯一标识
             */
            uuid?: string;
            /**
             * 时间跨度开始天数
             */
            startDays?: number;
            /**
             * 时间跨度结束天数
             */
            endDays?: number;
            /**
             * 区间金额（伙食）
             */
            amount: number;
            /**
             * 时间跨度其他 0否 1是
             */
            isDefault: number;
          }[];
          /**
           * 是否凭票报销：1是0否
           */
          isUseInvoice?: number;
          /**
           * 常住地编码（一,二,三级）
           */
          residence?: string;
          /**
           * 常住地名称（一,二,三级）
           * 浙江省,杭州市,西湖区
           */
          residenceName?: string;
        }[];
        /**
         * 特殊规则
         */
        specialData?: {
          /**
           * 前端唯一标识
           */
          uuid?: string;
          /**
           * 是否默认（其他）0否1是 基本规则才能是1
           */
          isDefault: number;
          /**
           * 出发地（特殊规则）
           */
          departure?: {
            /**
             * 区划名称
             */
            placeName: string;
            /**
             * 区划编码
             */
            placeCode: string;
            /**
             * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
             */
            placeLevel?: number;
            /**
             * 全路径区划编码
             */
            pathCodeChain: string;
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 区划名称
             */
            placeName: string;
            /**
             * 区划编码
             */
            placeCode: string;
            /**
             * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
             */
            placeLevel?: number;
            /**
             * 全路径区划编码
             */
            pathCodeChain: string;
          }[];
          /**
           * 时间跨度
           */
          dateConditionDTOS: {
            /**
             * 前端唯一标识
             */
            uuid?: string;
            /**
             * 时间跨度开始天数
             */
            startDays?: number;
            /**
             * 时间跨度结束天数
             */
            endDays?: number;
            /**
             * 区间金额（伙食）
             */
            amount: number;
            /**
             * 时间跨度其他 0否 1是
             */
            isDefault: number;
          }[];
          /**
           * 是否凭票报销：1是0否
           */
          isUseInvoice?: number;
          /**
           * 常住地编码（一,二,三级）
           */
          residence?: string;
          /**
           * 常住地名称（一,二,三级）
           * 浙江省,杭州市,西湖区
           */
          residenceName?: string;
        }[];
      }[];
      /**
       * 公杂费用项拓展字段
       */
      miscellaneousExtendDataDTOS?: {
        /**
         * 差旅类型
         */
        travelType: number;
        /**
         * 基本规则
         */
        normalData: {
          /**
           * 前端唯一标识
           */
          uuid?: string;
          /**
           * 是否默认（其他）0否1是 基本规则才能是1
           */
          isDefault: number;
          /**
           * 出发地（特殊规则）
           */
          departure?: {
            /**
             * 区划名称
             */
            placeName: string;
            /**
             * 区划编码
             */
            placeCode: string;
            /**
             * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
             */
            placeLevel?: number;
            /**
             * 全路径区划编码
             */
            pathCodeChain: string;
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 区划名称
             */
            placeName: string;
            /**
             * 区划编码
             */
            placeCode: string;
            /**
             * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
             */
            placeLevel?: number;
            /**
             * 全路径区划编码
             */
            pathCodeChain: string;
          }[];
          /**
           * 时间跨度
           */
          dateConditionDTOS: {
            /**
             * 前端唯一标识
             */
            uuid?: string;
            /**
             * 时间跨度开始天数
             */
            startDays?: number;
            /**
             * 时间跨度结束天数
             */
            endDays?: number;
            /**
             * 区间金额（派车公杂） 外派可能为空
             */
            sendCarAmount?: number;
            /**
             * 区间金额（不派车公杂）
             */
            notSendCarAmount: number;
            /**
             * 时间跨度其他 0否 1是
             */
            isDefault: number;
            /**
             * 外派每月补贴次数
             */
            allowanceTimes?: number;
            /**
             * 外派残月时间跨度
             */
            expatriateDateConditionList?: {
              /**
               * 时间跨度开始天数
               */
              startDays?: number;
              /**
               * 时间跨度结束天数
               */
              endDays?: number;
              /**
               * 外派每月补贴次数
               */
              allowanceTimes: number;
              /**
               * 时间跨度其他 0否 1是
               */
              isDefault: number;
              /**
               * 前端唯一标识
               */
              uuid?: string;
            }[];
          }[];
        }[];
        /**
         * 特殊规则
         */
        specialData?: {
          /**
           * 前端唯一标识
           */
          uuid?: string;
          /**
           * 是否默认（其他）0否1是 基本规则才能是1
           */
          isDefault: number;
          /**
           * 出发地（特殊规则）
           */
          departure?: {
            /**
             * 区划名称
             */
            placeName: string;
            /**
             * 区划编码
             */
            placeCode: string;
            /**
             * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
             */
            placeLevel?: number;
            /**
             * 全路径区划编码
             */
            pathCodeChain: string;
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 区划名称
             */
            placeName: string;
            /**
             * 区划编码
             */
            placeCode: string;
            /**
             * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
             */
            placeLevel?: number;
            /**
             * 全路径区划编码
             */
            pathCodeChain: string;
          }[];
          /**
           * 时间跨度
           */
          dateConditionDTOS: {
            /**
             * 前端唯一标识
             */
            uuid?: string;
            /**
             * 时间跨度开始天数
             */
            startDays?: number;
            /**
             * 时间跨度结束天数
             */
            endDays?: number;
            /**
             * 区间金额（派车公杂） 外派可能为空
             */
            sendCarAmount?: number;
            /**
             * 区间金额（不派车公杂）
             */
            notSendCarAmount: number;
            /**
             * 时间跨度其他 0否 1是
             */
            isDefault: number;
            /**
             * 外派每月补贴次数
             */
            allowanceTimes?: number;
            /**
             * 外派残月时间跨度
             */
            expatriateDateConditionList?: {
              /**
               * 时间跨度开始天数
               */
              startDays?: number;
              /**
               * 时间跨度结束天数
               */
              endDays?: number;
              /**
               * 外派每月补贴次数
               */
              allowanceTimes: number;
              /**
               * 时间跨度其他 0否 1是
               */
              isDefault: number;
              /**
               * 前端唯一标识
               */
              uuid?: string;
            }[];
          }[];
        }[];
      }[];
      /**
       * 短途包干费用项拓展字段
       */
      shortDistanceExtendDataDTOS?: {
        /**
         * 一级区划编码
         */
        firstArea: {
          /**
           * 区划名称
           */
          placeName: string;
          /**
           * 区划编码
           */
          placeCode: string;
          /**
           * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
           */
          placeLevel?: number;
          /**
           * 全路径区划编码
           */
          pathCodeChain: string;
        };
        /**
         * 表格内容
         */
        matrixData?: {
          /**
           * 出发地
           */
          departure: {
            /**
             * 区划名称
             */
            placeName: string;
            /**
             * 区划编码
             */
            placeCode: string;
            /**
             * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
             */
            placeLevel?: number;
            /**
             * 全路径区划编码
             */
            pathCodeChain: string;
          };
          /**
           * 目的地和金额列表
           */
          destination: {
            /**
             * 区划名称
             */
            placeName: string;
            /**
             * 区划编码
             */
            placeCode: string;
            /**
             * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
             */
            placeLevel?: number;
            /**
             * 全路径区划编码
             */
            pathCodeChain: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 往返金额
             */
            doubleRouteAmount?: number;
          }[];
        }[];
        /**
         * 是否往返配置
         * true：开启
         */
        doubleRoute?: boolean;
        /**
         * 前端字段快速回显
         */
        quickFill?: number;
      }[];
      /**
       * 会议-住宿费
       */
      meetingHotelExtendDataDTOS?: {
        /**
         * 会议级别
         */
        levelValue: number;
        /**
         * 会议级别名称
         */
        levelName: string;
        /**
         * 金额
         */
        amount: number;
      }[];
      /**
       * 会议-伙食费
       */
      meetingFoodExtendDataDTOS?: {
        /**
         * 会议级别
         */
        levelValue: number;
        /**
         * 会议级别名称
         */
        levelName: string;
        /**
         * 金额
         */
        amount: number;
      }[];
      /**
       * 会议-其他
       */
      meetingOtherExtendDataDTOS?: {
        /**
         * 会议级别
         */
        levelValue: number;
        /**
         * 会议级别名称
         */
        levelName: string;
        /**
         * 金额
         */
        amount: number;
      }[];
      /**
       * 培训-住宿费
       */
      trainingHotelExtendDataDTOS?: {
        /**
         * 培训级别
         */
        levelValue: number;
        /**
         * 培训级别名称
         */
        levelName: string;
        /**
         * 金额详情
         */
        data: {
          uuid?: string;
          /**
           * 时间跨度开始天数
           */
          startDays?: number;
          /**
           * 时间跨度结束天数
           */
          endDays?: number;
          /**
           * 金额
           */
          amount: number;
          /**
           * 是否默认（其他）
           */
          isDefault: number;
        }[];
      }[];
      /**
       * 培训-伙食费
       */
      trainingFoodExtendDataDTOS?: {
        /**
         * 培训级别
         */
        levelValue: number;
        /**
         * 培训级别名称
         */
        levelName: string;
        /**
         * 金额详情
         */
        data: {
          uuid?: string;
          /**
           * 时间跨度开始天数
           */
          startDays?: number;
          /**
           * 时间跨度结束天数
           */
          endDays?: number;
          /**
           * 金额
           */
          amount: number;
          /**
           * 是否默认（其他）
           */
          isDefault: number;
        }[];
      }[];
      /**
       * 培训-场地、资料、交通
       */
      trainingIncidentalExtendDataDTOS?: {
        /**
         * 培训级别
         */
        levelValue: number;
        /**
         * 培训级别名称
         */
        levelName: string;
        /**
         * 金额详情
         */
        data: {
          uuid?: string;
          /**
           * 时间跨度开始天数
           */
          startDays?: number;
          /**
           * 时间跨度结束天数
           */
          endDays?: number;
          /**
           * 金额
           */
          amount: number;
          /**
           * 是否默认（其他）
           */
          isDefault: number;
        }[];
      }[];
      /**
       * 培训-讲师费
       */
      trainingTeachExtendDataDTOS?: {
        /**
         * 讲师级别
         */
        levelValue: number;
        /**
         * 讲师级别名称
         */
        levelName: string;
        /**
         * 金额
         */
        amount: number;
      }[];
      /**
       * 培训-其他
       */
      trainingOtherExtendDataDTOS?: {
        /**
         * 培训级别
         */
        levelValue: number;
        /**
         * 培训级别名称
         */
        levelName: string;
        /**
         * 金额详情
         */
        data: {
          uuid?: string;
          /**
           * 时间跨度开始天数
           */
          startDays?: number;
          /**
           * 时间跨度结束天数
           */
          endDays?: number;
          /**
           * 金额
           */
          amount: number;
          /**
           * 是否默认（其他）
           */
          isDefault: number;
        }[];
      }[];
      /**
       * 公务接待-工作餐
       */
      receptionMealExtendDataDTOS?: {
        /**
         * 职级组名称
         */
        rankGroupCode: string;
        /**
         * 职级组名称
         */
        rankGroupName: string;
        /**
         * 金额
         */
        amount: number;
      }[];
      /**
       * 公务接待-其他
       */
      receptionOtherExtendDataDTOS?: {
        /**
         * 职级组名称
         */
        rankGroupCode: string;
        /**
         * 职级组名称
         */
        rankGroupName: string;
        /**
         * 金额
         */
        amount: number;
      }[];
      /**
       * 通用采购申请单-金额合计
       */
      purchaseExtendDataDTO?: {
        /**
         * 金额合计
         */
        amount: number;
      };
      /**
       * 办公设备家具购置申请单-家具
       */
      furnitureExtendDataDTOS?: {
        /**
         * 家具code
         */
        code: string;
        /**
         * 家具名称
         */
        name: string;
        /**
         * 详细数据
         */
        data: {
          /**
           * 职级组编号
           */
          rankGroupCode: string;
          /**
           * 职级组名称
           */
          rankGroupName: string;
          /**
           * 金额
           */
          amount: number;
        }[];
      }[];
      /**
       * 办公设备家具购置申请单-设备
       */
      equipmentExtendDataDTOS?: {
        /**
         * 设备code
         */
        code: string;
        /**
         * 设备名称
         */
        name: string;
        /**
         * 金额
         */
        amount: number;
      }[];
      /**
       * 夜餐费-夜餐费
       */
      overtimeExtendDataDTOS?: {
        /**
         * 前端唯一键
         */
        uuid?: string;
        /**
         * 0工作日 1休息日
         */
        dateType?: number;
        /**
         * 开始时间，只取时间，不管日期
         */
        startTime: string;
        /**
         * 结束时间，只取时间，不管日期
         */
        endTime: string;
        /**
         * 补贴金额,单位分
         */
        amount: number;
        /**
         * 加班时间和补贴次数
         */
        hoursAndTimesList: {
          /**
           * 前端唯一键
           */
          uuid?: string;
          /**
           * 连续加班时间
           */
          hours: number;
          /**
           * 补贴次数
           */
          times: number;
        }[];
      }[];
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询费用项规则详情↗](http://yapi.cai-inc.com/project/3705/interface/api/309074) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/query/{itemConfigCode}`
 * @更新时间 `2024-09-09 16:00:55`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemQueryItemConfigCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/query/{itemConfigCode}',
    'data',
    'itemConfigCode',
    string,
    false
  >
>;

/**
 * 接口 [查询费用项规则详情↗](http://yapi.cai-inc.com/project/3705/interface/api/309074) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/query/{itemConfigCode}`
 * @更新时间 `2024-09-09 16:00:55`
 * @项目ID 3705
 */
const zlbCostControlFeeItemQueryItemConfigCodeGetRequestConfig: ZlbCostControlFeeItemQueryItemConfigCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/query/{itemConfigCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: ['itemConfigCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemQueryItemConfigCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询费用项规则详情↗](http://yapi.cai-inc.com/project/3705/interface/api/309074) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/query/{itemConfigCode}`
 * @更新时间 `2024-09-09 16:00:55`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemQueryItemConfigCodeGet = /*#__PURE__*/ (
  requestData: ZlbCostControlFeeItemQueryItemConfigCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemQueryItemConfigCodeGetResponse>(
    prepare(zlbCostControlFeeItemQueryItemConfigCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemQueryItemConfigCodeGet.requestConfig =
  zlbCostControlFeeItemQueryItemConfigCodeGetRequestConfig;

/**
 * 接口 [删除费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309082) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/delete/{itemConfigCode}`
 * @更新时间 `2024-09-09 16:00:56`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemDeleteItemConfigCodePostRequest {
  itemConfigCode: string;
}

/**
 * 接口 [删除费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309082) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/delete/{itemConfigCode}`
 * @更新时间 `2024-09-09 16:00:56`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemDeleteItemConfigCodePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309082) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/delete/{itemConfigCode}`
 * @更新时间 `2024-09-09 16:00:56`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemDeleteItemConfigCodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/delete/{itemConfigCode}',
    'data',
    'itemConfigCode',
    string,
    false
  >
>;

/**
 * 接口 [删除费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309082) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/delete/{itemConfigCode}`
 * @更新时间 `2024-09-09 16:00:56`
 * @项目ID 3705
 */
const zlbCostControlFeeItemDeleteItemConfigCodePostRequestConfig: ZlbCostControlFeeItemDeleteItemConfigCodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/delete/{itemConfigCode}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: ['itemConfigCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemDeleteItemConfigCodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309082) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/delete/{itemConfigCode}`
 * @更新时间 `2024-09-09 16:00:56`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemDeleteItemConfigCodePost = /*#__PURE__*/ (
  requestData: ZlbCostControlFeeItemDeleteItemConfigCodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemDeleteItemConfigCodePostResponse>(
    prepare(zlbCostControlFeeItemDeleteItemConfigCodePostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemDeleteItemConfigCodePost.requestConfig =
  zlbCostControlFeeItemDeleteItemConfigCodePostRequestConfig;

/**
 * 接口 [检测费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309098) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/check`
 * @更新时间 `2024-09-09 16:00:56`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemCheckPostRequest {
  /**
   * 费用编码，主键
   */
  itemConfigCode: string;
  /**
   * 差旅交通费检测参数,火车、飞机、轮船
   */
  travelFeeItemConfigCheckPO?: {
    /**
     * 职级组编号
     */
    rankGroupCode: string;
    /**
     * 职级组名称
     */
    rankGroupName: string;
  };
  /**
   * 差旅住宿费检测参数
   */
  hotelFeeItemConfigCheckPO?: {
    /**
     * 出差地区
     */
    travelPlace?: {
      /**
       * 区划名称
       */
      placeName: string;
      /**
       * 区划编码
       */
      placeCode: string;
      /**
       * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
       */
      placeLevel?: number;
      /**
       * 全路径区划编码
       */
      pathCodeChain: string;
    };
    /**
     * 职级组编号
     */
    rankGroupCode: string;
  };
  /**
   * 差旅伙食费检测参数
   */
  foodFeeItemConfigCheckPO?: {
    /**
     * 差旅类型
     */
    travelType: number;
    /**
     * 出发地
     */
    departure: {
      /**
       * 区划名称
       */
      placeName: string;
      /**
       * 区划编码
       */
      placeCode: string;
      /**
       * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
       */
      placeLevel?: number;
      /**
       * 全路径区划编码
       */
      pathCodeChain: string;
    };
    /**
     * 目的地
     */
    destination: {
      /**
       * 区划名称
       */
      placeName: string;
      /**
       * 区划编码
       */
      placeCode: string;
      /**
       * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
       */
      placeLevel?: number;
      /**
       * 全路径区划编码
       */
      pathCodeChain: string;
    };
    /**
     * 时间跨度
     */
    days: number;
  };
  /**
   * 差旅公杂补贴检测参数
   */
  miscellaneousFeeItemConfigCheckPO?: {
    /**
     * 差旅类型
     */
    travelType: number;
    /**
     * 出发地
     */
    departure: {
      /**
       * 区划名称
       */
      placeName: string;
      /**
       * 区划编码
       */
      placeCode: string;
      /**
       * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
       */
      placeLevel?: number;
      /**
       * 全路径区划编码
       */
      pathCodeChain: string;
    };
    /**
     * 目的地
     */
    destination: {
      /**
       * 区划名称
       */
      placeName: string;
      /**
       * 区划编码
       */
      placeCode: string;
      /**
       * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
       */
      placeLevel?: number;
      /**
       * 全路径区划编码
       */
      pathCodeChain: string;
    };
    /**
     * 时间跨度
     */
    days?: number;
    /**
     * 是否派车
     */
    sendCar: boolean;
    /**
     * 开始时间
     */
    startDate?: string;
    /**
     * 结束时间
     */
    endDate?: string;
  };
  /**
   * 差旅短途包干检测参数
   */
  shortDistanceFeeItemConfigCheckPO?: {
    /**
     * 出发地
     */
    departure: {
      /**
       * 区划名称
       */
      placeName: string;
      /**
       * 区划编码
       */
      placeCode: string;
      /**
       * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
       */
      placeLevel?: number;
      /**
       * 全路径区划编码
       */
      pathCodeChain: string;
    };
    /**
     * 目的地
     */
    destination: {
      /**
       * 区划名称
       */
      placeName: string;
      /**
       * 区划编码
       */
      placeCode: string;
      /**
       * 区划等级 0全国 1省级 2市 3区县 可根据pathCodeChain里的，数量判断.伙食公杂没有传，短途包干传了
       */
      placeLevel?: number;
      /**
       * 全路径区划编码
       */
      pathCodeChain: string;
    };
  };
  /**
   * 会议费检测参数，会议伙食费、会议住宿费、会议其他费控
   */
  meetingFeeItemConfigCheckPO?: {
    /**
     * 会议级别
     */
    levelValue: number;
    /**
     * 会议级别名称
     */
    levelName: string;
  };
  /**
   * 培训费检测参数，培训伙食费、培训住宿费、培训场地费、培训其他费用
   */
  trainingFeeItemConfigCheckPO?: {
    /**
     * 培训级别
     */
    levelValue: number;
    /**
     * 培训级别名称
     */
    levelName: string;
    /**
     * 时间跨度
     */
    days: number;
  };
  /**
   * 培训讲师费检测参数，培训讲师费
   */
  trainingTechFeeItemConfigCheckPO?: {
    /**
     * 讲师级别
     */
    levelValue: number;
    /**
     * 讲师级别名称
     */
    levelName: string;
  };
  /**
   * 公务接待检测参数，公务接待工作餐
   */
  receptionFeeItemConfigCheckPO?: {
    /**
     * 职级组名称
     */
    rankGroupCode: string;
    /**
     * 职级组名称
     */
    rankGroupName: string;
  };
  /**
   * 办公家具检测参数
   */
  furnitureFeeItemConfigCheckPO?: {
    /**
     * 家具编号
     */
    code: string;
    /**
     * 家具名称
     */
    name: string;
    /**
     * 职级组编号
     */
    rankGroupCode: string;
    /**
     * 职级组名称
     */
    rankGroupName: string;
  };
  /**
   * 办公设备检测参数
   */
  equipmentFeeItemConfigCheckPO?: {
    /**
     * 设备code
     */
    code: string;
    /**
     * 设备名称
     */
    name: string;
  };
  /**
   * 夜餐费检测参数
   */
  overtimeFeeItemConfigCheckPO?: {
    /**
     * 开始时间，精确到分
     */
    startTime: string;
    /**
     * 结束时间，精确到分
     */
    endTime: string;
  };
}

/**
 * 接口 [检测费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309098) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/check`
 * @更新时间 `2024-09-09 16:00:56`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemCheckPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 检测的费用项编码，前端可根据此项判断渲染哪种结果
     */
    feeItemCode?:
      | '2001'
      | '2002'
      | '2003'
      | '2007'
      | '1001'
      | '3001'
      | '4001'
      | '5001'
      | '6001'
      | '7001'
      | '8001'
      | '9001'
      | '10001'
      | '11001'
      | '12001'
      | '13001'
      | '14001'
      | '16001'
      | '17001'
      | '18001'
      | '19001';
    /**
     * 差旅交通费检测结果,火车、飞机、轮船
     */
    travelFeeItemConfigCheckRO?: string;
    /**
     * 差旅住宿费检测结果
     */
    hotelFeeItemConfigCheckRO?: {
      /**
       * 费用标准
       */
      amount?: number;
      /**
       * 开始时间MMdd
       */
      start?: string;
      /**
       * 结束时间MMdd
       */
      end?: string;
    }[];
    /**
     * 差旅伙食费检测结果
     */
    foodFeeItemConfigCheckRO?: string;
    /**
     * 差旅公杂补贴检测结果
     */
    miscellaneousFeeItemConfigCheckRO?: {
      /**
       * 费用标准
       */
      amount?: number;
      /**
       * 外派每月补贴次数
       */
      allowanceTimes?: number;
      /**
       * 补贴总金额
       */
      allAmount?: number;
    };
    /**
     * 差旅短途包干检测结果
     */
    shortDistanceFeeItemConfigCheckRO?: number;
    /**
     * 会议伙食费检测结果，会议伙食费、会议住宿费、会议其他费控
     */
    meetingFeeItemConfigCheckRO?: number;
    /**
     * 培训伙食费检测结果，培训伙食费、培训住宿费、培训场地费、培训其他费用
     */
    trainingFeeItemConfigCheckRO?: number;
    /**
     * 培训讲师费检测结果，培训讲师费
     */
    trainingTechFeeItemConfigCheckRO?: number;
    /**
     * 公务接待工作餐检测结果，公务接待工作餐
     */
    receptionFeeItemConfigCheckRO?: number;
    /**
     * 办公家具检测结果
     */
    furnitureFeeItemConfigCheckRO?: number;
    /**
     * 办公设备检测结果
     */
    equipmentFeeItemConfigCheckRO?: number;
    /**
     * 夜餐费检测结果
     */
    overTimeFeeITemConfigCheckRO?: {
      /**
       * 检测结果
       */
      overtimeCheckResultDTOS?: {
        /**
         * 开始时间
         */
        startTime?: string;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 发放标准
         */
        standard?: number;
        /**
         * 次数
         */
        times?: number;
        /**
         * 夜餐费
         */
        amount?: number;
        /**
         * 是否是休息日，TRUE休息日，FALSE工作日
         */
        holidayFLag?: boolean;
      }[];
      /**
       * 总金额
       */
      totalAmount?: number;
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [检测费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309098) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/check`
 * @更新时间 `2024-09-09 16:00:56`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemCheckPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/check',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [检测费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309098) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/check`
 * @更新时间 `2024-09-09 16:00:56`
 * @项目ID 3705
 */
const zlbCostControlFeeItemCheckPostRequestConfig: ZlbCostControlFeeItemCheckPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/check',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemCheckPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [检测费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309098) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/check`
 * @更新时间 `2024-09-09 16:00:56`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemCheckPost = /*#__PURE__*/ (
  requestData: ZlbCostControlFeeItemCheckPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemCheckPostResponse>(
    prepare(zlbCostControlFeeItemCheckPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemCheckPost.requestConfig = zlbCostControlFeeItemCheckPostRequestConfig;

/**
 * 接口 [分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/309106) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/page`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemPagePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 费用项规则名称
   */
  itemConfigName?: string;
  /**
   * 单据类型
   */
  expenseFormType?: 1 | 2 | 3 | 6 | 4 | 11 | 15;
  /**
   * 费用分类
   */
  feeTypeCode?:
    | '20'
    | '10'
    | '30'
    | '40'
    | '50'
    | '60'
    | '70'
    | '80'
    | '90'
    | '100'
    | '110'
    | '120'
    | '130'
    | '140'
    | '160'
    | '170'
    | '180'
    | '190';
  /**
   * 费用项
   */
  feeItemCode?:
    | '2001'
    | '2002'
    | '2003'
    | '2007'
    | '1001'
    | '3001'
    | '4001'
    | '5001'
    | '6001'
    | '7001'
    | '8001'
    | '9001'
    | '10001'
    | '11001'
    | '12001'
    | '13001'
    | '14001'
    | '16001'
    | '17001'
    | '18001'
    | '19001';
  /**
   * 状态 0禁用 1启用
   */
  useStatus?: number;
}

/**
 * 接口 [分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/309106) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/page`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemPagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 费用项规则编码
       */
      itemConfigCode?: string;
      /**
       * 费用项规则名称
       */
      itemConfigName?: string;
      /**
       * 单据类型
       */
      expenseFormType?:
        | 1
        | 1
        | 1
        | 1
        | 1
        | 1
        | 1
        | 1
        | 2
        | 2
        | 2
        | 3
        | 3
        | 3
        | 3
        | 3
        | 6
        | 4
        | 11
        | 11
        | 15;
      /**
       * 单据类型名称
       */
      expenseFormTypeName?:
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '会议申请、报销单'
        | '会议申请、报销单'
        | '会议申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '公务接待报销单'
        | '办公用品采购申请单'
        | '办公家具设备购置申请单'
        | '办公家具设备购置申请单'
        | '夜餐费发放单';
      /**
       * 费用分类编码
       */
      feeType?:
        | '20'
        | '20'
        | '20'
        | '20'
        | '10'
        | '30'
        | '40'
        | '50'
        | '60'
        | '70'
        | '80'
        | '90'
        | '100'
        | '110'
        | '120'
        | '130'
        | '140'
        | '160'
        | '170'
        | '180'
        | '190';
      /**
       * 费用分类名称
       */
      feeTypeName?:
        | '交通费'
        | '交通费'
        | '交通费'
        | '交通费'
        | '住宿费'
        | '伙食补贴'
        | '公杂补贴'
        | '短途包干'
        | '住宿费'
        | '伙食费'
        | '其他'
        | '住宿费'
        | '伙食费'
        | '场地、资料、交通类'
        | '师资类'
        | '其他'
        | '工作餐费'
        | '默认分类'
        | '家具'
        | '设备'
        | '夜餐费';
      /**
       * 费用项编码
       */
      feeItemCode?:
        | '2001'
        | '2002'
        | '2003'
        | '2007'
        | '1001'
        | '3001'
        | '4001'
        | '5001'
        | '6001'
        | '7001'
        | '8001'
        | '9001'
        | '10001'
        | '11001'
        | '12001'
        | '13001'
        | '14001'
        | '16001'
        | '17001'
        | '18001'
        | '19001';
      /**
       * 费用项名称
       */
      feeItemName?: string;
      /**
       * 对应的规则引擎的策略编码
       */
      strategyCode?: string;
      /**
       * 控制等级编码
       */
      feeControlLevel?: number;
      /**
       * 控制等级编码
       */
      feeControlLevelName?: string;
      /**
       * 是否需要填超标原因编码
       */
      feeReasonNeed?: number;
      /**
       * 是否需要填超标原因编码
       */
      feeReasonNeedName?: string;
      /**
       * 状态 0禁用 1启用
       */
      useStatus?: number;
      /**
       * 状态展示字段
       */
      useStatusName?: string;
      /**
       * 更新人名称
       */
      updatedByName?: string;
      /**
       * 更新时间
       */
      rModifiedTime?: string;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/309106) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/page`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/309106) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/page`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
const zlbCostControlFeeItemPagePostRequestConfig: ZlbCostControlFeeItemPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/309106) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/page`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemPagePost = /*#__PURE__*/ (
  requestData: ZlbCostControlFeeItemPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemPagePostResponse>(
    prepare(zlbCostControlFeeItemPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemPagePost.requestConfig = zlbCostControlFeeItemPagePostRequestConfig;

/**
 * 接口 [费用项规则是否关联费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/311970) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/standard-relation-count/{itemConfigCode}`
 * @更新时间 `2024-09-09 16:00:55`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemStandardRelationCountItemConfigCodeGetRequest {
  itemConfigCode: string;
}

/**
 * 接口 [费用项规则是否关联费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/311970) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/standard-relation-count/{itemConfigCode}`
 * @更新时间 `2024-09-09 16:00:55`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemStandardRelationCountItemConfigCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 被关联数量
     */
    count?: number;
    /**
     * 已关联的租户/机构名称
     */
    standardCodeList?: string[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费用项规则是否关联费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/311970) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/standard-relation-count/{itemConfigCode}`
 * @更新时间 `2024-09-09 16:00:55`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemStandardRelationCountItemConfigCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/standard-relation-count/{itemConfigCode}',
    'data',
    'itemConfigCode',
    string,
    false
  >
>;

/**
 * 接口 [费用项规则是否关联费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/311970) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/standard-relation-count/{itemConfigCode}`
 * @更新时间 `2024-09-09 16:00:55`
 * @项目ID 3705
 */
const zlbCostControlFeeItemStandardRelationCountItemConfigCodeGetRequestConfig: ZlbCostControlFeeItemStandardRelationCountItemConfigCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/standard-relation-count/{itemConfigCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: ['itemConfigCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemStandardRelationCountItemConfigCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费用项规则是否关联费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/311970) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/standard-relation-count/{itemConfigCode}`
 * @更新时间 `2024-09-09 16:00:55`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemStandardRelationCountItemConfigCodeGet = /*#__PURE__*/ (
  requestData: ZlbCostControlFeeItemStandardRelationCountItemConfigCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemStandardRelationCountItemConfigCodeGetResponse>(
    prepare(zlbCostControlFeeItemStandardRelationCountItemConfigCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemStandardRelationCountItemConfigCodeGet.requestConfig =
  zlbCostControlFeeItemStandardRelationCountItemConfigCodeGetRequestConfig;

/**
 * 接口 [修改费用项规则状态 -0禁用 1启用↗](http://yapi.cai-inc.com/project/3705/interface/api/311978) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/change-status`
 * @更新时间 `2024-09-09 16:00:56`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemChangeStatusPostRequest {
  /**
   * 费用项规则编号
   */
  itemConfigCode: string;
  /**
   * 修改后的状态
   */
  useStatus: number;
}

/**
 * 接口 [修改费用项规则状态 -0禁用 1启用↗](http://yapi.cai-inc.com/project/3705/interface/api/311978) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/change-status`
 * @更新时间 `2024-09-09 16:00:56`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemChangeStatusPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [修改费用项规则状态 -0禁用 1启用↗](http://yapi.cai-inc.com/project/3705/interface/api/311978) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/change-status`
 * @更新时间 `2024-09-09 16:00:56`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemChangeStatusPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/change-status',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [修改费用项规则状态 -0禁用 1启用↗](http://yapi.cai-inc.com/project/3705/interface/api/311978) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/change-status`
 * @更新时间 `2024-09-09 16:00:56`
 * @项目ID 3705
 */
const zlbCostControlFeeItemChangeStatusPostRequestConfig: ZlbCostControlFeeItemChangeStatusPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/change-status',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemChangeStatusPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [修改费用项规则状态 -0禁用 1启用↗](http://yapi.cai-inc.com/project/3705/interface/api/311978) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `POST /zlb/cost/control/fee-item/change-status`
 * @更新时间 `2024-09-09 16:00:56`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemChangeStatusPost = /*#__PURE__*/ (
  requestData: ZlbCostControlFeeItemChangeStatusPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemChangeStatusPostResponse>(
    prepare(zlbCostControlFeeItemChangeStatusPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemChangeStatusPost.requestConfig =
  zlbCostControlFeeItemChangeStatusPostRequestConfig;

/**
 * 接口 [分页查询的条件，报销单类型->费用类型->费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/314602) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/list-condition`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemListConditionGetRequest {}

/**
 * 接口 [分页查询的条件，报销单类型->费用类型->费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/314602) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/list-condition`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemListConditionGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 单据类型
     */
    expenseFormType?:
      | 1
      | 1
      | 1
      | 1
      | 1
      | 1
      | 1
      | 1
      | 2
      | 2
      | 2
      | 3
      | 3
      | 3
      | 3
      | 3
      | 6
      | 4
      | 11
      | 11
      | 15;
    /**
     * 单据类型名称
     */
    expenseFormTypeName?:
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '会议申请、报销单'
      | '会议申请、报销单'
      | '会议申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '公务接待报销单'
      | '办公用品采购申请单'
      | '办公家具设备购置申请单'
      | '办公家具设备购置申请单'
      | '夜餐费发放单';
    /**
     * 费用类型列表
     */
    typeConditionROs?: {
      /**
       * 费用分类编码
       */
      feeType?:
        | '20'
        | '20'
        | '20'
        | '20'
        | '10'
        | '30'
        | '40'
        | '50'
        | '60'
        | '70'
        | '80'
        | '90'
        | '100'
        | '110'
        | '120'
        | '130'
        | '140'
        | '160'
        | '170'
        | '180'
        | '190';
      /**
       * 费用分类名称
       */
      feeTypeName?:
        | '交通费'
        | '交通费'
        | '交通费'
        | '交通费'
        | '住宿费'
        | '伙食补贴'
        | '公杂补贴'
        | '短途包干'
        | '住宿费'
        | '伙食费'
        | '其他'
        | '住宿费'
        | '伙食费'
        | '场地、资料、交通类'
        | '师资类'
        | '其他'
        | '工作餐费'
        | '默认分类'
        | '家具'
        | '设备'
        | '夜餐费';
      /**
       * 费用项列表
       */
      itemConditionROs?: {
        /**
         * 费用项编码
         */
        feeItemCode?:
          | '2001'
          | '2002'
          | '2003'
          | '2007'
          | '1001'
          | '3001'
          | '4001'
          | '5001'
          | '6001'
          | '7001'
          | '8001'
          | '9001'
          | '10001'
          | '11001'
          | '12001'
          | '13001'
          | '14001'
          | '16001'
          | '17001'
          | '18001'
          | '19001';
        /**
         * 费用项名称
         */
        feeItemName?: string;
      }[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [分页查询的条件，报销单类型->费用类型->费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/314602) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/list-condition`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemListConditionGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/list-condition',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [分页查询的条件，报销单类型->费用类型->费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/314602) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/list-condition`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
const zlbCostControlFeeItemListConditionGetRequestConfig: ZlbCostControlFeeItemListConditionGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/list-condition',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemListConditionGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [分页查询的条件，报销单类型->费用类型->费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/314602) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/list-condition`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemListConditionGet = /*#__PURE__*/ (
  requestData?: ZlbCostControlFeeItemListConditionGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemListConditionGetResponse>(
    prepare(zlbCostControlFeeItemListConditionGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemListConditionGet.requestConfig =
  zlbCostControlFeeItemListConditionGetRequestConfig;

/**
 * 接口 [交通费座位标准↗](http://yapi.cai-inc.com/project/3705/interface/api/314610) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/seat-level`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemSeatLevelGetRequest {}

/**
 * 接口 [交通费座位标准↗](http://yapi.cai-inc.com/project/3705/interface/api/314610) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/seat-level`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemSeatLevelGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 座位标准code
     */
    code?: string;
    desc?: string;
    child?: {
      /**
       * 座位标准code
       */
      code?: string;
      desc?: string;
      child?: {}[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [交通费座位标准↗](http://yapi.cai-inc.com/project/3705/interface/api/314610) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/seat-level`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemSeatLevelGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/seat-level',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [交通费座位标准↗](http://yapi.cai-inc.com/project/3705/interface/api/314610) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/seat-level`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
const zlbCostControlFeeItemSeatLevelGetRequestConfig: ZlbCostControlFeeItemSeatLevelGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/seat-level',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemSeatLevelGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [交通费座位标准↗](http://yapi.cai-inc.com/project/3705/interface/api/314610) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/seat-level`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemSeatLevelGet = /*#__PURE__*/ (
  requestData?: ZlbCostControlFeeItemSeatLevelGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemSeatLevelGetResponse>(
    prepare(zlbCostControlFeeItemSeatLevelGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemSeatLevelGet.requestConfig = zlbCostControlFeeItemSeatLevelGetRequestConfig;

/**
 * 接口 [差旅类型↗](http://yapi.cai-inc.com/project/3705/interface/api/314626) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/travel-type`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemTravelTypeGetRequest {}

/**
 * 接口 [差旅类型↗](http://yapi.cai-inc.com/project/3705/interface/api/314626) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/travel-type`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemTravelTypeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * code
     */
    code?: number;
    /**
     * desc
     */
    desc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [差旅类型↗](http://yapi.cai-inc.com/project/3705/interface/api/314626) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/travel-type`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemTravelTypeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/travel-type',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [差旅类型↗](http://yapi.cai-inc.com/project/3705/interface/api/314626) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/travel-type`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
const zlbCostControlFeeItemTravelTypeGetRequestConfig: ZlbCostControlFeeItemTravelTypeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/travel-type',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemTravelTypeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [差旅类型↗](http://yapi.cai-inc.com/project/3705/interface/api/314626) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/travel-type`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemTravelTypeGet = /*#__PURE__*/ (
  requestData?: ZlbCostControlFeeItemTravelTypeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemTravelTypeGetResponse>(
    prepare(zlbCostControlFeeItemTravelTypeGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemTravelTypeGet.requestConfig = zlbCostControlFeeItemTravelTypeGetRequestConfig;

/**
 * 接口 [讲师级别↗](http://yapi.cai-inc.com/project/3705/interface/api/318074) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/lecturer-level`
 * @更新时间 `2024-09-09 16:00:51`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemLecturerLevelGetRequest {}

/**
 * 接口 [讲师级别↗](http://yapi.cai-inc.com/project/3705/interface/api/318074) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/lecturer-level`
 * @更新时间 `2024-09-09 16:00:51`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemLecturerLevelGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * code
     */
    code?: number;
    /**
     * desc
     */
    desc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [讲师级别↗](http://yapi.cai-inc.com/project/3705/interface/api/318074) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/lecturer-level`
 * @更新时间 `2024-09-09 16:00:51`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemLecturerLevelGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/lecturer-level',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [讲师级别↗](http://yapi.cai-inc.com/project/3705/interface/api/318074) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/lecturer-level`
 * @更新时间 `2024-09-09 16:00:51`
 * @项目ID 3705
 */
const zlbCostControlFeeItemLecturerLevelGetRequestConfig: ZlbCostControlFeeItemLecturerLevelGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/lecturer-level',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemLecturerLevelGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [讲师级别↗](http://yapi.cai-inc.com/project/3705/interface/api/318074) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/lecturer-level`
 * @更新时间 `2024-09-09 16:00:51`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemLecturerLevelGet = /*#__PURE__*/ (
  requestData?: ZlbCostControlFeeItemLecturerLevelGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemLecturerLevelGetResponse>(
    prepare(zlbCostControlFeeItemLecturerLevelGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemLecturerLevelGet.requestConfig =
  zlbCostControlFeeItemLecturerLevelGetRequestConfig;

/**
 * 接口 [家具设备列表 家具 1； 设备 2↗](http://yapi.cai-inc.com/project/3705/interface/api/321874) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/furniture-equipment/{type}`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemFurnitureEquipmentTypeGetRequest {
  type: string;
}

/**
 * 接口 [家具设备列表 家具 1； 设备 2↗](http://yapi.cai-inc.com/project/3705/interface/api/321874) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/furniture-equipment/{type}`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemFurnitureEquipmentTypeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * code
     */
    code?: string;
    /**
     * desc
     */
    desc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [家具设备列表 家具 1； 设备 2↗](http://yapi.cai-inc.com/project/3705/interface/api/321874) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/furniture-equipment/{type}`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemFurnitureEquipmentTypeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/furniture-equipment/{type}',
    'data',
    'type',
    string,
    false
  >
>;

/**
 * 接口 [家具设备列表 家具 1； 设备 2↗](http://yapi.cai-inc.com/project/3705/interface/api/321874) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/furniture-equipment/{type}`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
const zlbCostControlFeeItemFurnitureEquipmentTypeGetRequestConfig: ZlbCostControlFeeItemFurnitureEquipmentTypeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/furniture-equipment/{type}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: ['type'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemFurnitureEquipmentTypeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [家具设备列表 家具 1； 设备 2↗](http://yapi.cai-inc.com/project/3705/interface/api/321874) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/furniture-equipment/{type}`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemFurnitureEquipmentTypeGet = /*#__PURE__*/ (
  requestData: ZlbCostControlFeeItemFurnitureEquipmentTypeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemFurnitureEquipmentTypeGetResponse>(
    prepare(zlbCostControlFeeItemFurnitureEquipmentTypeGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemFurnitureEquipmentTypeGet.requestConfig =
  zlbCostControlFeeItemFurnitureEquipmentTypeGetRequestConfig;

/**
 * 接口 [人员职级 差旅交通费-住宿费-公务接待 1; 办公家具采购申请单 2↗](http://yapi.cai-inc.com/project/3705/interface/api/321954) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/personnel-level/{type}`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemPersonnelLevelTypeGetRequest {
  type: string;
}

/**
 * 接口 [人员职级 差旅交通费-住宿费-公务接待 1; 办公家具采购申请单 2↗](http://yapi.cai-inc.com/project/3705/interface/api/321954) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/personnel-level/{type}`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemPersonnelLevelTypeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * code
     */
    code?: string;
    /**
     * desc
     */
    desc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [人员职级 差旅交通费-住宿费-公务接待 1; 办公家具采购申请单 2↗](http://yapi.cai-inc.com/project/3705/interface/api/321954) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/personnel-level/{type}`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemPersonnelLevelTypeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/personnel-level/{type}',
    'data',
    'type',
    string,
    false
  >
>;

/**
 * 接口 [人员职级 差旅交通费-住宿费-公务接待 1; 办公家具采购申请单 2↗](http://yapi.cai-inc.com/project/3705/interface/api/321954) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/personnel-level/{type}`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
const zlbCostControlFeeItemPersonnelLevelTypeGetRequestConfig: ZlbCostControlFeeItemPersonnelLevelTypeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/personnel-level/{type}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: ['type'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemPersonnelLevelTypeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [人员职级 差旅交通费-住宿费-公务接待 1; 办公家具采购申请单 2↗](http://yapi.cai-inc.com/project/3705/interface/api/321954) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/personnel-level/{type}`
 * @更新时间 `2024-09-09 16:00:50`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemPersonnelLevelTypeGet = /*#__PURE__*/ (
  requestData: ZlbCostControlFeeItemPersonnelLevelTypeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemPersonnelLevelTypeGetResponse>(
    prepare(zlbCostControlFeeItemPersonnelLevelTypeGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemPersonnelLevelTypeGet.requestConfig =
  zlbCostControlFeeItemPersonnelLevelTypeGetRequestConfig;

/**
 * 接口 [会议级别列表↗](http://yapi.cai-inc.com/project/3705/interface/api/325626) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/meeting-level`
 * @更新时间 `2024-09-09 16:00:51`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemMeetingLevelGetRequest {}

/**
 * 接口 [会议级别列表↗](http://yapi.cai-inc.com/project/3705/interface/api/325626) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/meeting-level`
 * @更新时间 `2024-09-09 16:00:51`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemMeetingLevelGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * code
     */
    code?: number;
    /**
     * desc
     */
    desc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [会议级别列表↗](http://yapi.cai-inc.com/project/3705/interface/api/325626) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/meeting-level`
 * @更新时间 `2024-09-09 16:00:51`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemMeetingLevelGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/meeting-level',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [会议级别列表↗](http://yapi.cai-inc.com/project/3705/interface/api/325626) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/meeting-level`
 * @更新时间 `2024-09-09 16:00:51`
 * @项目ID 3705
 */
const zlbCostControlFeeItemMeetingLevelGetRequestConfig: ZlbCostControlFeeItemMeetingLevelGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/meeting-level',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemMeetingLevelGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [会议级别列表↗](http://yapi.cai-inc.com/project/3705/interface/api/325626) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/meeting-level`
 * @更新时间 `2024-09-09 16:00:51`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemMeetingLevelGet = /*#__PURE__*/ (
  requestData?: ZlbCostControlFeeItemMeetingLevelGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemMeetingLevelGetResponse>(
    prepare(zlbCostControlFeeItemMeetingLevelGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemMeetingLevelGet.requestConfig =
  zlbCostControlFeeItemMeetingLevelGetRequestConfig;

/**
 * 接口 [培训级别列表↗](http://yapi.cai-inc.com/project/3705/interface/api/325642) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/training-level`
 * @更新时间 `2024-09-09 16:00:51`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemTrainingLevelGetRequest {}

/**
 * 接口 [培训级别列表↗](http://yapi.cai-inc.com/project/3705/interface/api/325642) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/training-level`
 * @更新时间 `2024-09-09 16:00:51`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemTrainingLevelGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * code
     */
    code?: number;
    /**
     * desc
     */
    desc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [培训级别列表↗](http://yapi.cai-inc.com/project/3705/interface/api/325642) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/training-level`
 * @更新时间 `2024-09-09 16:00:51`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemTrainingLevelGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/training-level',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [培训级别列表↗](http://yapi.cai-inc.com/project/3705/interface/api/325642) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/training-level`
 * @更新时间 `2024-09-09 16:00:51`
 * @项目ID 3705
 */
const zlbCostControlFeeItemTrainingLevelGetRequestConfig: ZlbCostControlFeeItemTrainingLevelGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/training-level',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemTrainingLevelGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [培训级别列表↗](http://yapi.cai-inc.com/project/3705/interface/api/325642) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/training-level`
 * @更新时间 `2024-09-09 16:00:51`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemTrainingLevelGet = /*#__PURE__*/ (
  requestData?: ZlbCostControlFeeItemTrainingLevelGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemTrainingLevelGetResponse>(
    prepare(zlbCostControlFeeItemTrainingLevelGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemTrainingLevelGet.requestConfig =
  zlbCostControlFeeItemTrainingLevelGetRequestConfig;

/**
 * 接口 [校验名称是否可用↗](http://yapi.cai-inc.com/project/3705/interface/api/338882) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/check-name`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemCheckNameGetRequest {
  /**
   * 费用项名称
   */
  itemConfigName: string;
  /**
   * 费用项编码，更新费用项规则时传入
   */
  itemConfigCode?: string;
}

/**
 * 接口 [校验名称是否可用↗](http://yapi.cai-inc.com/project/3705/interface/api/338882) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/check-name`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
export interface ZlbCostControlFeeItemCheckNameGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {};
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [校验名称是否可用↗](http://yapi.cai-inc.com/project/3705/interface/api/338882) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/check-name`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
type ZlbCostControlFeeItemCheckNameGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/fee-item/check-name',
    'data',
    string,
    'itemConfigName' | 'itemConfigCode',
    false
  >
>;

/**
 * 接口 [校验名称是否可用↗](http://yapi.cai-inc.com/project/3705/interface/api/338882) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/check-name`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
const zlbCostControlFeeItemCheckNameGetRequestConfig: ZlbCostControlFeeItemCheckNameGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/zlb/cost/control/fee-item/check-name',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: ['itemConfigName', 'itemConfigCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlFeeItemCheckNameGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [校验名称是否可用↗](http://yapi.cai-inc.com/project/3705/interface/api/338882) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用项配置↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48639)
 * @请求头 `GET /zlb/cost/control/fee-item/check-name`
 * @更新时间 `2024-09-09 16:00:52`
 * @项目ID 3705
 */
export const zlbCostControlFeeItemCheckNameGet = /*#__PURE__*/ (
  requestData: ZlbCostControlFeeItemCheckNameGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlFeeItemCheckNameGetResponse>(
    prepare(zlbCostControlFeeItemCheckNameGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlFeeItemCheckNameGet.requestConfig = zlbCostControlFeeItemCheckNameGetRequestConfig;

const mockUrl_0_0_0_1 = 'http://yapi.cai-inc.com/mock/3705' as any;
const devUrl_0_0_0_1 = '' as any;
const prodUrl_0_0_0_1 = '' as any;
const dataKey_0_0_0_1 = 'data' as any;

/**
 * 接口 [费控规则标准查询（分页）↗](http://yapi.cai-inc.com/project/3705/interface/api/250600) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/page`
 * @更新时间 `2023-07-26 10:35:26`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardPagePostRequest {
  /**
   * 平台费控id
   */
  costControlId?: string;
  /**
   * 费控标准名称
   */
  costControlName?: string;
  /**
   * 区划Code
   */
  districtCode?: string;
  /**
   * 机构id
   */
  orgId?: number;
  /**
   * 单位统一社会信用代码
   */
  creditCode?: string;
  /**
   * 当前页码
   */
  pageNo?: number;
  /**
   * 每页记录数
   */
  pageSize?: number;
}

/**
 * 接口 [费控规则标准查询（分页）↗](http://yapi.cai-inc.com/project/3705/interface/api/250600) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/page`
 * @更新时间 `2023-07-26 10:35:26`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardPagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      id?: number;
      /**
       * 平台费控id
       */
      costControlId?: string;
      /**
       * 费控标准名称
       */
      costControlName?: string;
      /**
       * 状态（0：关闭，1：启用）
       */
      status?: number;
      /**
       * 状态名称
       */
      statusName?: string;
      /**
       * 备注
       */
      remarks?: string;
      /**
       * 修改时间
       */
      rModifiedTime?: string;
      /**
       * 关联区划
       */
      districtNum?: number;
      /**
       * 关联费用规则
       */
      ruleNum?: number;
      /**
       * 更新人
       */
      updaterName?: string;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费控规则标准查询（分页）↗](http://yapi.cai-inc.com/project/3705/interface/api/250600) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/page`
 * @更新时间 `2023-07-26 10:35:26`
 * @项目ID 3705
 */
type ZlbCostControlStandardPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/standard/page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [费控规则标准查询（分页）↗](http://yapi.cai-inc.com/project/3705/interface/api/250600) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/page`
 * @更新时间 `2023-07-26 10:35:26`
 * @项目ID 3705
 */
const zlbCostControlStandardPagePostRequestConfig: ZlbCostControlStandardPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/zlb/cost/control/standard/page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlStandardPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费控规则标准查询（分页）↗](http://yapi.cai-inc.com/project/3705/interface/api/250600) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/page`
 * @更新时间 `2023-07-26 10:35:26`
 * @项目ID 3705
 */
export const zlbCostControlStandardPagePost = /*#__PURE__*/ (
  requestData: ZlbCostControlStandardPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlStandardPagePostResponse>(
    prepare(zlbCostControlStandardPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlStandardPagePost.requestConfig = zlbCostControlStandardPagePostRequestConfig;

/**
 * 接口 [删除费用标准规则↗](http://yapi.cai-inc.com/project/3705/interface/api/250606) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `DELETE /zlb/cost/control/standard/delete/{id}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardDeleteIdDeleteRequest {
  id: string;
}

/**
 * 接口 [删除费用标准规则↗](http://yapi.cai-inc.com/project/3705/interface/api/250606) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `DELETE /zlb/cost/control/standard/delete/{id}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardDeleteIdDeleteResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除费用标准规则↗](http://yapi.cai-inc.com/project/3705/interface/api/250606) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `DELETE /zlb/cost/control/standard/delete/{id}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
type ZlbCostControlStandardDeleteIdDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/standard/delete/{id}',
    'data',
    'id',
    string,
    false
  >
>;

/**
 * 接口 [删除费用标准规则↗](http://yapi.cai-inc.com/project/3705/interface/api/250606) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `DELETE /zlb/cost/control/standard/delete/{id}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
const zlbCostControlStandardDeleteIdDeleteRequestConfig: ZlbCostControlStandardDeleteIdDeleteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/zlb/cost/control/standard/delete/{id}',
    method: Method.DELETE,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: ['id'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlStandardDeleteIdDelete',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除费用标准规则↗](http://yapi.cai-inc.com/project/3705/interface/api/250606) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `DELETE /zlb/cost/control/standard/delete/{id}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
export const zlbCostControlStandardDeleteIdDelete = /*#__PURE__*/ (
  requestData: ZlbCostControlStandardDeleteIdDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlStandardDeleteIdDeleteResponse>(
    prepare(zlbCostControlStandardDeleteIdDeleteRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlStandardDeleteIdDelete.requestConfig =
  zlbCostControlStandardDeleteIdDeleteRequestConfig;

/**
 * 接口 [保存费用标准规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309346) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/save`
 * @更新时间 `2023-07-26 10:35:26`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardSavePostRequest {
  costControlId?: string;
  /**
   * 费控标准名称
   */
  costControlName: string;
  /**
   * 状态（0：关闭，1：启用）
   */
  status: number;
  /**
   * 备注
   */
  remarks?: string;
  /**
   * 操作人id
   */
  operatorId?: number;
  /**
   * 区划/租户
   */
  districts?: {
    /**
     * 区划code
     */
    districtCode: string;
    /**
     * 区划名称
     */
    districtName: string;
  }[];
  /**
   * 单位
   */
  orgs?: {
    /**
     * 单位ID
     */
    orgId: number;
    /**
     * 单位名称
     */
    orgName: string;
  }[];
  /**
   * 费用规则
   */
  itemConfigs?: {
    /**
     * 报销单类型
     */
    expenseFormType?:
      | 1
      | 1
      | 1
      | 1
      | 1
      | 1
      | 1
      | 1
      | 2
      | 2
      | 2
      | 3
      | 3
      | 3
      | 3
      | 3
      | 6
      | 4
      | 11
      | 11;
    /**
     * 报销单类型
     */
    expenseFormTypeName?:
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '会议申请、报销单'
      | '会议申请、报销单'
      | '会议申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '公务接待报销单'
      | '办公用品采购申请单'
      | '办公家具设备购置申请单'
      | '办公家具设备购置申请单';
    /**
     * 费用项配置
     */
    itemConfigList?: {
      /**
       * 费用类型
       */
      feeTypeCode?: string;
      /**
       * 费用类型名称
       */
      feeTypeName?: string;
      /**
       * 费用项编码
       */
      feeItemCode?: string;
      /**
       * 费用项名称
       */
      feeItemName?: string;
      /**
       * 费用项配置编码
       */
      itemConfigCode?: string;
      /**
       * 费用项配置名称
       */
      itemConfigName?: string;
      /**
       * 平台费控id
       */
      costControlId?: string;
      /**
       * 费控标准名称
       */
      costControlName?: string;
    }[];
  }[];
  /**
   * 综合定额
   */
  compositeFeeItems?: {
    /**
     * 报销单类型
     */
    expenseFormType?: number;
    /**
     * 报销类型名称
     */
    expenseFormTypeName?: string;
    /**
     * 费用分类
     */
    feeTypeList?: {
      /**
       * 费用分类编码
       */
      feeTypeCode?: string;
      /**
       * 费用分类名称
       */
      feeTypeName?: string;
      /**
       * 费用项配置
       */
      feeItemInfoList?: {
        /**
         * 费用项编码
         */
        feeItemCode?: string;
        /**
         * 费用项名称
         */
        feeItemName?: string;
      }[];
    }[];
  }[];
  /**
   * 是否默认（通用标准）1是0否
   */
  isDefault?: number;
}

/**
 * 接口 [保存费用标准规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309346) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/save`
 * @更新时间 `2023-07-26 10:35:26`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardSavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存费用标准规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309346) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/save`
 * @更新时间 `2023-07-26 10:35:26`
 * @项目ID 3705
 */
type ZlbCostControlStandardSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/standard/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存费用标准规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309346) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/save`
 * @更新时间 `2023-07-26 10:35:26`
 * @项目ID 3705
 */
const zlbCostControlStandardSavePostRequestConfig: ZlbCostControlStandardSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/zlb/cost/control/standard/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlStandardSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存费用标准规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309346) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/save`
 * @更新时间 `2023-07-26 10:35:26`
 * @项目ID 3705
 */
export const zlbCostControlStandardSavePost = /*#__PURE__*/ (
  requestData: ZlbCostControlStandardSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlStandardSavePostResponse>(
    prepare(zlbCostControlStandardSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlStandardSavePost.requestConfig = zlbCostControlStandardSavePostRequestConfig;

/**
 * 接口 [根据平台费控id查询费控标准↗](http://yapi.cai-inc.com/project/3705/interface/api/309354) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-by-id/{id}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardGetByIdIdGetRequest {
  id: string;
}

/**
 * 接口 [根据平台费控id查询费控标准↗](http://yapi.cai-inc.com/project/3705/interface/api/309354) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-by-id/{id}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardGetByIdIdGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    id?: number;
    /**
     * 平台费控id
     */
    costControlId?: string;
    /**
     * 费控标准名称
     */
    costControlName?: string;
    /**
     * 状态（0：关闭，1：启用）
     */
    status?: number;
    /**
     * 状态名称
     */
    statusName?: string;
    /**
     * 备注
     */
    remarks?: string;
    /**
     * 区划
     */
    districts?: {
      id?: number;
      /**
       * 区划code
       */
      districtCode?: string;
      /**
       * 区划名称
       */
      districtName?: string;
      /**
       * 区划归属
       */
      districtPath?: string;
      /**
       * 租户类型
       */
      tenantType?: string;
      /**
       * 租户类型描述
       */
      tenantTypeName?: string;
    }[];
    /**
     * 单位
     */
    orgROS?: {
      /**
       * 单位ID
       */
      orgId?: number;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 单位统一社会信用代码
       */
      creditCode?: string;
      /**
       * 区划Code
       */
      districtCode?: string;
      /**
       * 区划名称
       */
      districtName?: string;
    }[];
    /**
     * 费用规则配置
     */
    itemConfigs?: {
      /**
       * 报销单类型
       */
      expenseFormType?:
        | 1
        | 1
        | 1
        | 1
        | 1
        | 1
        | 1
        | 1
        | 2
        | 2
        | 2
        | 3
        | 3
        | 3
        | 3
        | 3
        | 6
        | 4
        | 11
        | 11;
      /**
       * 报销单类型
       */
      expenseFormTypeName?:
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '会议申请、报销单'
        | '会议申请、报销单'
        | '会议申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '公务接待报销单'
        | '办公用品采购申请单'
        | '办公家具设备购置申请单'
        | '办公家具设备购置申请单';
      /**
       * 费用项配置
       */
      itemConfigList?: {
        /**
         * 费用类型
         */
        feeTypeCode?: string;
        /**
         * 费用类型名称
         */
        feeTypeName?: string;
        /**
         * 费用项编码
         */
        feeItemCode?: string;
        /**
         * 费用项名称
         */
        feeItemName?: string;
        /**
         * 费用项配置编码
         */
        itemConfigCode?: string;
        /**
         * 费用项配置名称
         */
        itemConfigName?: string;
        /**
         * 平台费控id
         */
        costControlId?: string;
        /**
         * 费控标准名称
         */
        costControlName?: string;
      }[];
    }[];
    /**
     * 综合定额
     */
    compositeFeeItems?: {
      /**
       * 报销单类型
       */
      expenseFormType?: number;
      /**
       * 报销类型名称
       */
      expenseFormTypeName?: string;
      /**
       * 费用分类
       */
      feeTypeList?: {
        /**
         * 费用分类编码
         */
        feeTypeCode?: string;
        /**
         * 费用分类名称
         */
        feeTypeName?: string;
        /**
         * 费用项配置
         */
        feeItemInfoList?: {
          /**
           * 费用项编码
           */
          feeItemCode?: string;
          /**
           * 费用项名称
           */
          feeItemName?: string;
        }[];
      }[];
    }[];
    /**
     * 是否默认（通用标准）1是0否
     */
    isDefault?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据平台费控id查询费控标准↗](http://yapi.cai-inc.com/project/3705/interface/api/309354) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-by-id/{id}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
type ZlbCostControlStandardGetByIdIdGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/standard/get-by-id/{id}',
    'data',
    'id',
    string,
    false
  >
>;

/**
 * 接口 [根据平台费控id查询费控标准↗](http://yapi.cai-inc.com/project/3705/interface/api/309354) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-by-id/{id}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
const zlbCostControlStandardGetByIdIdGetRequestConfig: ZlbCostControlStandardGetByIdIdGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/zlb/cost/control/standard/get-by-id/{id}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: ['id'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlStandardGetByIdIdGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据平台费控id查询费控标准↗](http://yapi.cai-inc.com/project/3705/interface/api/309354) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-by-id/{id}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
export const zlbCostControlStandardGetByIdIdGet = /*#__PURE__*/ (
  requestData: ZlbCostControlStandardGetByIdIdGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlStandardGetByIdIdGetResponse>(
    prepare(zlbCostControlStandardGetByIdIdGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlStandardGetByIdIdGet.requestConfig = zlbCostControlStandardGetByIdIdGetRequestConfig;

/**
 * 接口 [根据区划code查询费控规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309362) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-by-district/{districtCode}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardGetByDistrictDistrictCodeGetRequest {
  districtCode: string;
}

/**
 * 接口 [根据区划code查询费控规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309362) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-by-district/{districtCode}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardGetByDistrictDistrictCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    id?: number;
    /**
     * 平台费控id
     */
    costControlId?: string;
    /**
     * 费控标准名称
     */
    costControlName?: string;
    /**
     * 状态（0：关闭，1：启用）
     */
    status?: number;
    /**
     * 状态名称
     */
    statusName?: string;
    /**
     * 备注
     */
    remarks?: string;
    /**
     * 区划
     */
    districts?: {
      id?: number;
      /**
       * 区划code
       */
      districtCode?: string;
      /**
       * 区划名称
       */
      districtName?: string;
      /**
       * 区划归属
       */
      districtPath?: string;
      /**
       * 租户类型
       */
      tenantType?: string;
      /**
       * 租户类型描述
       */
      tenantTypeName?: string;
    }[];
    /**
     * 单位
     */
    orgROS?: {
      /**
       * 单位ID
       */
      orgId?: number;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 单位统一社会信用代码
       */
      creditCode?: string;
      /**
       * 区划Code
       */
      districtCode?: string;
      /**
       * 区划名称
       */
      districtName?: string;
    }[];
    /**
     * 费用规则配置
     */
    itemConfigs?: {
      /**
       * 报销单类型
       */
      expenseFormType?:
        | 1
        | 1
        | 1
        | 1
        | 1
        | 1
        | 1
        | 1
        | 2
        | 2
        | 2
        | 3
        | 3
        | 3
        | 3
        | 3
        | 6
        | 4
        | 11
        | 11;
      /**
       * 报销单类型
       */
      expenseFormTypeName?:
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '会议申请、报销单'
        | '会议申请、报销单'
        | '会议申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '公务接待报销单'
        | '办公用品采购申请单'
        | '办公家具设备购置申请单'
        | '办公家具设备购置申请单';
      /**
       * 费用项配置
       */
      itemConfigList?: {
        /**
         * 费用类型
         */
        feeTypeCode?: string;
        /**
         * 费用类型名称
         */
        feeTypeName?: string;
        /**
         * 费用项编码
         */
        feeItemCode?: string;
        /**
         * 费用项名称
         */
        feeItemName?: string;
        /**
         * 费用项配置编码
         */
        itemConfigCode?: string;
        /**
         * 费用项配置名称
         */
        itemConfigName?: string;
        /**
         * 平台费控id
         */
        costControlId?: string;
        /**
         * 费控标准名称
         */
        costControlName?: string;
      }[];
    }[];
    /**
     * 综合定额
     */
    compositeFeeItems?: {
      /**
       * 报销单类型
       */
      expenseFormType?: number;
      /**
       * 报销类型名称
       */
      expenseFormTypeName?: string;
      /**
       * 费用分类
       */
      feeTypeList?: {
        /**
         * 费用分类编码
         */
        feeTypeCode?: string;
        /**
         * 费用分类名称
         */
        feeTypeName?: string;
        /**
         * 费用项配置
         */
        feeItemInfoList?: {
          /**
           * 费用项编码
           */
          feeItemCode?: string;
          /**
           * 费用项名称
           */
          feeItemName?: string;
        }[];
      }[];
    }[];
    /**
     * 是否默认（通用标准）1是0否
     */
    isDefault?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据区划code查询费控规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309362) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-by-district/{districtCode}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
type ZlbCostControlStandardGetByDistrictDistrictCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/standard/get-by-district/{districtCode}',
    'data',
    'districtCode',
    string,
    false
  >
>;

/**
 * 接口 [根据区划code查询费控规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309362) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-by-district/{districtCode}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
const zlbCostControlStandardGetByDistrictDistrictCodeGetRequestConfig: ZlbCostControlStandardGetByDistrictDistrictCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/zlb/cost/control/standard/get-by-district/{districtCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: ['districtCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlStandardGetByDistrictDistrictCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据区划code查询费控规则↗](http://yapi.cai-inc.com/project/3705/interface/api/309362) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-by-district/{districtCode}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
export const zlbCostControlStandardGetByDistrictDistrictCodeGet = /*#__PURE__*/ (
  requestData: ZlbCostControlStandardGetByDistrictDistrictCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlStandardGetByDistrictDistrictCodeGetResponse>(
    prepare(zlbCostControlStandardGetByDistrictDistrictCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlStandardGetByDistrictDistrictCodeGet.requestConfig =
  zlbCostControlStandardGetByDistrictDistrictCodeGetRequestConfig;

/**
 * 接口 [查询区划是否存在费控标准中↗](http://yapi.cai-inc.com/project/3705/interface/api/309370) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/check-contains`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardCheckContainsPostRequest {
  /**
   * 区划
   */
  districtCodes?: string[];
  /**
   * 平台费控id
   */
  costControlId?: string;
}

/**
 * 接口 [查询区划是否存在费控标准中↗](http://yapi.cai-inc.com/project/3705/interface/api/309370) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/check-contains`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardCheckContainsPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 存在数量
     */
    existNum?: number;
    checkList?: {
      id?: number;
      /**
       * 区划code
       */
      districtCode?: string;
      /**
       * 区划名称
       */
      districtName?: string;
      /**
       * 区划归属
       */
      districtPath?: string;
      /**
       * 租户类型
       */
      tenantType?: string;
      /**
       * 租户类型描述
       */
      tenantTypeName?: string;
      /**
       * true：存在
       * false：不存在
       */
      isExist?: boolean;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询区划是否存在费控标准中↗](http://yapi.cai-inc.com/project/3705/interface/api/309370) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/check-contains`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
type ZlbCostControlStandardCheckContainsPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/standard/check-contains',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询区划是否存在费控标准中↗](http://yapi.cai-inc.com/project/3705/interface/api/309370) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/check-contains`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
const zlbCostControlStandardCheckContainsPostRequestConfig: ZlbCostControlStandardCheckContainsPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/zlb/cost/control/standard/check-contains',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlStandardCheckContainsPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询区划是否存在费控标准中↗](http://yapi.cai-inc.com/project/3705/interface/api/309370) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/check-contains`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
export const zlbCostControlStandardCheckContainsPost = /*#__PURE__*/ (
  requestData: ZlbCostControlStandardCheckContainsPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlStandardCheckContainsPostResponse>(
    prepare(zlbCostControlStandardCheckContainsPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlStandardCheckContainsPost.requestConfig =
  zlbCostControlStandardCheckContainsPostRequestConfig;

/**
 * 接口 [费用标准配置费用项初始化数据↗](http://yapi.cai-inc.com/project/3705/interface/api/319986) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-config-init-data`
 * @更新时间 `2023-08-25 14:35:35`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardGetConfigInitDataGetRequest {}

/**
 * 接口 [费用标准配置费用项初始化数据↗](http://yapi.cai-inc.com/project/3705/interface/api/319986) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-config-init-data`
 * @更新时间 `2023-08-25 14:35:35`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardGetConfigInitDataGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 报销单类型
     */
    expenseFormType?:
      | 1
      | 1
      | 1
      | 1
      | 1
      | 1
      | 1
      | 1
      | 2
      | 2
      | 2
      | 3
      | 3
      | 3
      | 3
      | 3
      | 6
      | 4
      | 11
      | 11
      | 15;
    /**
     * 报销单类型
     */
    expenseFormTypeName?:
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '差旅报销单'
      | '会议申请、报销单'
      | '会议申请、报销单'
      | '会议申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '培训申请、报销单'
      | '公务接待报销单'
      | '办公用品采购申请单'
      | '办公家具设备购置申请单'
      | '办公家具设备购置申请单'
      | '夜餐费发放单';
    /**
     * 费用项配置
     */
    itemConfigList?: {
      /**
       * 费用类型
       */
      feeTypeCode?: string;
      /**
       * 费用类型名称
       */
      feeTypeName?: string;
      /**
       * 费用项编码
       */
      feeItemCode?: string;
      /**
       * 费用项名称
       */
      feeItemName?: string;
      /**
       * 费用项配置编码
       */
      itemConfigCode?: string;
      /**
       * 费用项配置名称
       */
      itemConfigName?: string;
      /**
       * 平台费控id
       */
      costControlId?: string;
      /**
       * 费控标准名称
       */
      costControlName?: string;
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费用标准配置费用项初始化数据↗](http://yapi.cai-inc.com/project/3705/interface/api/319986) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-config-init-data`
 * @更新时间 `2023-08-25 14:35:35`
 * @项目ID 3705
 */
type ZlbCostControlStandardGetConfigInitDataGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/standard/get-config-init-data',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [费用标准配置费用项初始化数据↗](http://yapi.cai-inc.com/project/3705/interface/api/319986) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-config-init-data`
 * @更新时间 `2023-08-25 14:35:35`
 * @项目ID 3705
 */
const zlbCostControlStandardGetConfigInitDataGetRequestConfig: ZlbCostControlStandardGetConfigInitDataGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/zlb/cost/control/standard/get-config-init-data',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlStandardGetConfigInitDataGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费用标准配置费用项初始化数据↗](http://yapi.cai-inc.com/project/3705/interface/api/319986) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-config-init-data`
 * @更新时间 `2023-08-25 14:35:35`
 * @项目ID 3705
 */
export const zlbCostControlStandardGetConfigInitDataGet = /*#__PURE__*/ (
  requestData?: ZlbCostControlStandardGetConfigInitDataGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlStandardGetConfigInitDataGetResponse>(
    prepare(zlbCostControlStandardGetConfigInitDataGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlStandardGetConfigInitDataGet.requestConfig =
  zlbCostControlStandardGetConfigInitDataGetRequestConfig;

/**
 * 接口 [查询默认费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/328146) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-default`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardGetDefaultGetRequest {}

/**
 * 接口 [查询默认费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/328146) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-default`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardGetDefaultGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    id?: number;
    /**
     * 平台费控id
     */
    costControlId?: string;
    /**
     * 费控标准名称
     */
    costControlName?: string;
    /**
     * 状态（0：关闭，1：启用）
     */
    status?: number;
    /**
     * 状态名称
     */
    statusName?: string;
    /**
     * 备注
     */
    remarks?: string;
    /**
     * 区划
     */
    districts?: {
      id?: number;
      /**
       * 区划code
       */
      districtCode?: string;
      /**
       * 区划名称
       */
      districtName?: string;
      /**
       * 区划归属
       */
      districtPath?: string;
      /**
       * 租户类型
       */
      tenantType?: string;
      /**
       * 租户类型描述
       */
      tenantTypeName?: string;
    }[];
    /**
     * 单位
     */
    orgROS?: {
      /**
       * 单位ID
       */
      orgId?: number;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 单位统一社会信用代码
       */
      creditCode?: string;
      /**
       * 区划Code
       */
      districtCode?: string;
      /**
       * 区划名称
       */
      districtName?: string;
    }[];
    /**
     * 费用规则配置
     */
    itemConfigs?: {
      /**
       * 报销单类型
       */
      expenseFormType?:
        | 1
        | 1
        | 1
        | 1
        | 1
        | 1
        | 1
        | 1
        | 2
        | 2
        | 2
        | 3
        | 3
        | 3
        | 3
        | 3
        | 6
        | 4
        | 11
        | 11;
      /**
       * 报销单类型
       */
      expenseFormTypeName?:
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '会议申请、报销单'
        | '会议申请、报销单'
        | '会议申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '公务接待报销单'
        | '办公用品采购申请单'
        | '办公家具设备购置申请单'
        | '办公家具设备购置申请单';
      /**
       * 费用项配置
       */
      itemConfigList?: {
        /**
         * 费用类型
         */
        feeTypeCode?: string;
        /**
         * 费用类型名称
         */
        feeTypeName?: string;
        /**
         * 费用项编码
         */
        feeItemCode?: string;
        /**
         * 费用项名称
         */
        feeItemName?: string;
        /**
         * 费用项配置编码
         */
        itemConfigCode?: string;
        /**
         * 费用项配置名称
         */
        itemConfigName?: string;
        /**
         * 平台费控id
         */
        costControlId?: string;
        /**
         * 费控标准名称
         */
        costControlName?: string;
      }[];
    }[];
    /**
     * 综合定额
     */
    compositeFeeItems?: {
      /**
       * 报销单类型
       */
      expenseFormType?: number;
      /**
       * 报销类型名称
       */
      expenseFormTypeName?: string;
      /**
       * 费用分类
       */
      feeTypeList?: {
        /**
         * 费用分类编码
         */
        feeTypeCode?: string;
        /**
         * 费用分类名称
         */
        feeTypeName?: string;
        /**
         * 费用项配置
         */
        feeItemInfoList?: {
          /**
           * 费用项编码
           */
          feeItemCode?: string;
          /**
           * 费用项名称
           */
          feeItemName?: string;
        }[];
      }[];
    }[];
    /**
     * 是否默认（通用标准）1是0否
     */
    isDefault?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询默认费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/328146) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-default`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
type ZlbCostControlStandardGetDefaultGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/standard/get-default',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [查询默认费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/328146) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-default`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
const zlbCostControlStandardGetDefaultGetRequestConfig: ZlbCostControlStandardGetDefaultGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/zlb/cost/control/standard/get-default',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlStandardGetDefaultGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询默认费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/328146) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-default`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
export const zlbCostControlStandardGetDefaultGet = /*#__PURE__*/ (
  requestData?: ZlbCostControlStandardGetDefaultGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlStandardGetDefaultGetResponse>(
    prepare(zlbCostControlStandardGetDefaultGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlStandardGetDefaultGet.requestConfig =
  zlbCostControlStandardGetDefaultGetRequestConfig;

/**
 * 接口 [根据区划code获取区划全路径↗](http://yapi.cai-inc.com/project/3705/interface/api/410898) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-district-path-by-code/{code}`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardGetDistrictPathByCodeCodeGetRequest {
  code: string;
}

/**
 * 接口 [根据区划code获取区划全路径↗](http://yapi.cai-inc.com/project/3705/interface/api/410898) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-district-path-by-code/{code}`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardGetDistrictPathByCodeCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据区划code获取区划全路径↗](http://yapi.cai-inc.com/project/3705/interface/api/410898) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-district-path-by-code/{code}`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
type ZlbCostControlStandardGetDistrictPathByCodeCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/standard/get-district-path-by-code/{code}',
    'data',
    'code',
    string,
    false
  >
>;

/**
 * 接口 [根据区划code获取区划全路径↗](http://yapi.cai-inc.com/project/3705/interface/api/410898) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-district-path-by-code/{code}`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
const zlbCostControlStandardGetDistrictPathByCodeCodeGetRequestConfig: ZlbCostControlStandardGetDistrictPathByCodeCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/zlb/cost/control/standard/get-district-path-by-code/{code}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: ['code'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlStandardGetDistrictPathByCodeCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据区划code获取区划全路径↗](http://yapi.cai-inc.com/project/3705/interface/api/410898) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-district-path-by-code/{code}`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
export const zlbCostControlStandardGetDistrictPathByCodeCodeGet = /*#__PURE__*/ (
  requestData: ZlbCostControlStandardGetDistrictPathByCodeCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlStandardGetDistrictPathByCodeCodeGetResponse>(
    prepare(zlbCostControlStandardGetDistrictPathByCodeCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlStandardGetDistrictPathByCodeCodeGet.requestConfig =
  zlbCostControlStandardGetDistrictPathByCodeCodeGetRequestConfig;

/**
 * 接口 [根据单位id查询费控规则↗](http://yapi.cai-inc.com/project/3705/interface/api/410906) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-by-org-id/{orgId}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardGetByOrgIdOrgIdGetRequest {
  orgId: string;
}

/**
 * 接口 [根据单位id查询费控规则↗](http://yapi.cai-inc.com/project/3705/interface/api/410906) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-by-org-id/{orgId}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardGetByOrgIdOrgIdGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    id?: number;
    /**
     * 平台费控id
     */
    costControlId?: string;
    /**
     * 费控标准名称
     */
    costControlName?: string;
    /**
     * 状态（0：关闭，1：启用）
     */
    status?: number;
    /**
     * 状态名称
     */
    statusName?: string;
    /**
     * 备注
     */
    remarks?: string;
    /**
     * 区划
     */
    districts?: {
      id?: number;
      /**
       * 区划code
       */
      districtCode?: string;
      /**
       * 区划名称
       */
      districtName?: string;
      /**
       * 区划归属
       */
      districtPath?: string;
      /**
       * 租户类型
       */
      tenantType?: string;
      /**
       * 租户类型描述
       */
      tenantTypeName?: string;
    }[];
    /**
     * 单位
     */
    orgROS?: {
      /**
       * 单位ID
       */
      orgId?: number;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 单位统一社会信用代码
       */
      creditCode?: string;
      /**
       * 区划Code
       */
      districtCode?: string;
      /**
       * 区划名称
       */
      districtName?: string;
    }[];
    /**
     * 费用规则配置
     */
    itemConfigs?: {
      /**
       * 报销单类型
       */
      expenseFormType?:
        | 1
        | 1
        | 1
        | 1
        | 1
        | 1
        | 1
        | 1
        | 2
        | 2
        | 2
        | 3
        | 3
        | 3
        | 3
        | 3
        | 6
        | 4
        | 11
        | 11;
      /**
       * 报销单类型
       */
      expenseFormTypeName?:
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '差旅报销单'
        | '会议申请、报销单'
        | '会议申请、报销单'
        | '会议申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '培训申请、报销单'
        | '公务接待报销单'
        | '办公用品采购申请单'
        | '办公家具设备购置申请单'
        | '办公家具设备购置申请单';
      /**
       * 费用项配置
       */
      itemConfigList?: {
        /**
         * 费用类型
         */
        feeTypeCode?: string;
        /**
         * 费用类型名称
         */
        feeTypeName?: string;
        /**
         * 费用项编码
         */
        feeItemCode?: string;
        /**
         * 费用项名称
         */
        feeItemName?: string;
        /**
         * 费用项配置编码
         */
        itemConfigCode?: string;
        /**
         * 费用项配置名称
         */
        itemConfigName?: string;
        /**
         * 平台费控id
         */
        costControlId?: string;
        /**
         * 费控标准名称
         */
        costControlName?: string;
      }[];
    }[];
    /**
     * 综合定额
     */
    compositeFeeItems?: {
      /**
       * 报销单类型
       */
      expenseFormType?: number;
      /**
       * 报销类型名称
       */
      expenseFormTypeName?: string;
      /**
       * 费用分类
       */
      feeTypeList?: {
        /**
         * 费用分类编码
         */
        feeTypeCode?: string;
        /**
         * 费用分类名称
         */
        feeTypeName?: string;
        /**
         * 费用项配置
         */
        feeItemInfoList?: {
          /**
           * 费用项编码
           */
          feeItemCode?: string;
          /**
           * 费用项名称
           */
          feeItemName?: string;
        }[];
      }[];
    }[];
    /**
     * 是否默认（通用标准）1是0否
     */
    isDefault?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据单位id查询费控规则↗](http://yapi.cai-inc.com/project/3705/interface/api/410906) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-by-org-id/{orgId}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
type ZlbCostControlStandardGetByOrgIdOrgIdGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/standard/get-by-org-id/{orgId}',
    'data',
    'orgId',
    string,
    false
  >
>;

/**
 * 接口 [根据单位id查询费控规则↗](http://yapi.cai-inc.com/project/3705/interface/api/410906) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-by-org-id/{orgId}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
const zlbCostControlStandardGetByOrgIdOrgIdGetRequestConfig: ZlbCostControlStandardGetByOrgIdOrgIdGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/zlb/cost/control/standard/get-by-org-id/{orgId}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: ['orgId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlStandardGetByOrgIdOrgIdGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据单位id查询费控规则↗](http://yapi.cai-inc.com/project/3705/interface/api/410906) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/get-by-org-id/{orgId}`
 * @更新时间 `2023-07-26 10:35:27`
 * @项目ID 3705
 */
export const zlbCostControlStandardGetByOrgIdOrgIdGet = /*#__PURE__*/ (
  requestData: ZlbCostControlStandardGetByOrgIdOrgIdGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlStandardGetByOrgIdOrgIdGetResponse>(
    prepare(zlbCostControlStandardGetByOrgIdOrgIdGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlStandardGetByOrgIdOrgIdGet.requestConfig =
  zlbCostControlStandardGetByOrgIdOrgIdGetRequestConfig;

/**
 * 接口 [查询单位是否存在费控标准中↗](http://yapi.cai-inc.com/project/3705/interface/api/410914) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/check-org-contains`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardCheckOrgContainsPostRequest {
  /**
   * 机构ID
   */
  orgIds?: number[];
  /**
   * 平台费控id
   */
  costControlId: string;
}

/**
 * 接口 [查询单位是否存在费控标准中↗](http://yapi.cai-inc.com/project/3705/interface/api/410914) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/check-org-contains`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardCheckOrgContainsPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 存在数量
     */
    existNum?: number;
    /**
     * 校验结果
     */
    checkList?: {
      /**
       * 单位ID
       */
      orgId?: number;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 单位统一社会信用代码
       */
      creditCode?: string;
      /**
       * 区划Code
       */
      districtCode?: string;
      /**
       * 区划名称
       */
      districtName?: string;
      /**
       * true：存在
       * false：不存在
       */
      isExist?: boolean;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询单位是否存在费控标准中↗](http://yapi.cai-inc.com/project/3705/interface/api/410914) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/check-org-contains`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
type ZlbCostControlStandardCheckOrgContainsPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/standard/check-org-contains',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询单位是否存在费控标准中↗](http://yapi.cai-inc.com/project/3705/interface/api/410914) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/check-org-contains`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
const zlbCostControlStandardCheckOrgContainsPostRequestConfig: ZlbCostControlStandardCheckOrgContainsPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/zlb/cost/control/standard/check-org-contains',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlStandardCheckOrgContainsPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询单位是否存在费控标准中↗](http://yapi.cai-inc.com/project/3705/interface/api/410914) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `POST /zlb/cost/control/standard/check-org-contains`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
export const zlbCostControlStandardCheckOrgContainsPost = /*#__PURE__*/ (
  requestData: ZlbCostControlStandardCheckOrgContainsPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlStandardCheckOrgContainsPostResponse>(
    prepare(zlbCostControlStandardCheckOrgContainsPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlStandardCheckOrgContainsPost.requestConfig =
  zlbCostControlStandardCheckOrgContainsPostRequestConfig;

/**
 * 接口 [获取租户树↗](http://yapi.cai-inc.com/project/3705/interface/api/434906) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/tenant-tree`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardTenantTreeGetRequest {
  /**
   * 可选，不传返回全量租户树，传了只返回对应节点和直属一层节点(不传name的情况下)
   */
  tenantCode?: string;
  /**
   * 可选，使用name在tenantCode下模糊搜索，会返回全部节点
   */
  name?: string;
}

/**
 * 接口 [获取租户树↗](http://yapi.cai-inc.com/project/3705/interface/api/434906) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/tenant-tree`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
export interface ZlbCostControlStandardTenantTreeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 主键ID
     */
    id?: number;
    /**
     * 名称
     */
    name?: string;
    /**
     * 上级ID
     */
    parentId?: number;
    /**
     * 是否为叶子节点
     */
    leaf?: boolean;
    /**
     * 孩子节点
     */
    children?: {
      /**
       * 主键ID
       */
      id?: number;
      /**
       * 名称
       */
      name?: string;
      /**
       * 上级ID
       */
      parentId?: number;
      /**
       * 是否为叶子节点
       */
      leaf?: boolean;
      /**
       * 孩子节点
       */
      children?: {}[];
      /**
       * 租户编码
       */
      code?: string;
      /**
       * 租户状态
       */
      status?: number;
      /**
       * 行政区划类型
       */
      type?: string;
      /**
       * 订阅状态
       */
      subscribe?: boolean;
    }[];
    /**
     * 租户编码
     */
    code?: string;
    /**
     * 租户状态
     */
    status?: number;
    /**
     * 行政区划类型
     */
    type?: string;
    /**
     * 订阅状态
     */
    subscribe?: boolean;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取租户树↗](http://yapi.cai-inc.com/project/3705/interface/api/434906) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/tenant-tree`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
type ZlbCostControlStandardTenantTreeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/standard/tenant-tree',
    'data',
    string,
    'tenantCode' | 'name',
    false
  >
>;

/**
 * 接口 [获取租户树↗](http://yapi.cai-inc.com/project/3705/interface/api/434906) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/tenant-tree`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
const zlbCostControlStandardTenantTreeGetRequestConfig: ZlbCostControlStandardTenantTreeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/zlb/cost/control/standard/tenant-tree',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: ['tenantCode', 'name'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlStandardTenantTreeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取租户树↗](http://yapi.cai-inc.com/project/3705/interface/api/434906) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_48672)
 * @请求头 `GET /zlb/cost/control/standard/tenant-tree`
 * @更新时间 `2023-07-26 10:35:28`
 * @项目ID 3705
 */
export const zlbCostControlStandardTenantTreeGet = /*#__PURE__*/ (
  requestData: ZlbCostControlStandardTenantTreeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlStandardTenantTreeGetResponse>(
    prepare(zlbCostControlStandardTenantTreeGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlStandardTenantTreeGet.requestConfig =
  zlbCostControlStandardTenantTreeGetRequestConfig;

const mockUrl_0_0_0_2 = 'http://yapi.cai-inc.com/mock/3705' as any;
const devUrl_0_0_0_2 = '' as any;
const prodUrl_0_0_0_2 = '' as any;
const dataKey_0_0_0_2 = 'data' as any;

/**
 * 接口 [单据列表↗](http://yapi.cai-inc.com/project/3705/interface/api/526234) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/form-list`
 * @更新时间 `2023-10-11 10:11:00`
 * @项目ID 3705
 */
export interface ZlbCostControlBdStandardFormListPostRequest {
  /**
   * 是否继承上级配置(机构继承租户，租户继承通用)
   * 单据列表，费用项列表，总额定额详情接口使用
   */
  inherit?: boolean;
  /**
   * 单据名称模糊搜索
   */
  formName?: string;
  /**
   * 费用标准类型，1系统 2租户 3机构
   */
  standardLevel: number;
  /**
   * 机构ID， level为3时必传
   */
  orgId?: number;
  /**
   * 租户code，level为2时必传
   */
  tenantCode?: string;
}

/**
 * 接口 [单据列表↗](http://yapi.cai-inc.com/project/3705/interface/api/526234) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/form-list`
 * @更新时间 `2023-10-11 10:11:00`
 * @项目ID 3705
 */
export interface ZlbCostControlBdStandardFormListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 系统单据
     */
    systemFormList?: {
      /**
       * 单据编码
       */
      formTypeCode?: string;
      /**
       * 单据名称
       */
      formTypeName?: string;
      /**
       * 单据级别 1系统 2百搭
       */
      formLevel?: number;
      /**
       * 已配置费用项规则的费用项数量
       */
      configuredCount?: number;
      /**
       * 费用项数量
       */
      totalCount?: number;
    }[];
    /**
     * 租户自建单据
     */
    tenantFormList?: {
      /**
       * 单据编码
       */
      formTypeCode?: string;
      /**
       * 单据名称
       */
      formTypeName?: string;
      /**
       * 单据级别 1系统 2百搭
       */
      formLevel?: number;
      /**
       * 已配置费用项规则的费用项数量
       */
      configuredCount?: number;
      /**
       * 费用项数量
       */
      totalCount?: number;
    }[];
    /**
     * 机构自建
     */
    orgFormList?: {
      /**
       * 单据编码
       */
      formTypeCode?: string;
      /**
       * 单据名称
       */
      formTypeName?: string;
      /**
       * 单据级别 1系统 2百搭
       */
      formLevel?: number;
      /**
       * 已配置费用项规则的费用项数量
       */
      configuredCount?: number;
      /**
       * 费用项数量
       */
      totalCount?: number;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [单据列表↗](http://yapi.cai-inc.com/project/3705/interface/api/526234) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/form-list`
 * @更新时间 `2023-10-11 10:11:00`
 * @项目ID 3705
 */
type ZlbCostControlBdStandardFormListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/standard/form-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [单据列表↗](http://yapi.cai-inc.com/project/3705/interface/api/526234) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/form-list`
 * @更新时间 `2023-10-11 10:11:00`
 * @项目ID 3705
 */
const zlbCostControlBdStandardFormListPostRequestConfig: ZlbCostControlBdStandardFormListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/zlb/cost/control/bd/standard/form-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdStandardFormListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [单据列表↗](http://yapi.cai-inc.com/project/3705/interface/api/526234) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/form-list`
 * @更新时间 `2023-10-11 10:11:00`
 * @项目ID 3705
 */
export const zlbCostControlBdStandardFormListPost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdStandardFormListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdStandardFormListPostResponse>(
    prepare(zlbCostControlBdStandardFormListPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdStandardFormListPost.requestConfig =
  zlbCostControlBdStandardFormListPostRequestConfig;

/**
 * 接口 [单据费用项列表↗](http://yapi.cai-inc.com/project/3705/interface/api/526242) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/form-fee-item-list`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
export interface ZlbCostControlBdStandardFormFeeItemListPostRequest {
  /**
   * 是否继承上级配置(机构继承租户，租户继承通用)
   * 单据列表，费用项列表，总额定额详情接口使用
   */
  inherit?: boolean;
  /**
   * 单据类型code
   */
  fromTypeCode: string;
  /**
   * 单据级别 1系统 2百搭
   */
  formLevel: number;
  /**
   * 费用标准类型，1系统 2租户 3机构
   */
  standardLevel: number;
  /**
   * 机构ID， level为3时必传
   */
  orgId?: number;
  /**
   * 租户code，level为2时必传
   */
  tenantCode?: string;
}

/**
 * 接口 [单据费用项列表↗](http://yapi.cai-inc.com/project/3705/interface/api/526242) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/form-fee-item-list`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
export interface ZlbCostControlBdStandardFormFeeItemListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 费用项分类编码
     */
    feeItemCategoryCode?: string;
    /**
     * 费用项分类名称
     */
    feeItemCategoryName?: string;
    /**
     * 费用项编码
     */
    feeItemCode?: string;
    /**
     * 费用项名称
     */
    feeItemName?: string;
    /**
     * 费用项规则编码
     */
    feeItemConfigCode?: string;
    /**
     * 费用项规则名称
     */
    feeItemConfigName?: string;
    /**
     * 更新人
     */
    updaterName?: string;
    /**
     * 更新时间
     */
    updateTime?: string;
    /**
     * 费用项规则停启用状态,系统单据为null
     */
    useStatus?: number;
    /**
     * 状态描述,系统单据为null
     */
    useStatusDesc?: string;
    /**
     * 是否已配置，已配置TRUE
     */
    configFlag?: boolean;
    /**
     * 自定义费用项唯一编码
     */
    feeCustomizeUniqueCode?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [单据费用项列表↗](http://yapi.cai-inc.com/project/3705/interface/api/526242) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/form-fee-item-list`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
type ZlbCostControlBdStandardFormFeeItemListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/standard/form-fee-item-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [单据费用项列表↗](http://yapi.cai-inc.com/project/3705/interface/api/526242) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/form-fee-item-list`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
const zlbCostControlBdStandardFormFeeItemListPostRequestConfig: ZlbCostControlBdStandardFormFeeItemListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/zlb/cost/control/bd/standard/form-fee-item-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdStandardFormFeeItemListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [单据费用项列表↗](http://yapi.cai-inc.com/project/3705/interface/api/526242) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/form-fee-item-list`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
export const zlbCostControlBdStandardFormFeeItemListPost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdStandardFormFeeItemListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdStandardFormFeeItemListPostResponse>(
    prepare(zlbCostControlBdStandardFormFeeItemListPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdStandardFormFeeItemListPost.requestConfig =
  zlbCostControlBdStandardFormFeeItemListPostRequestConfig;

/**
 * 接口 [费用项规则绑定到机构\/租户下↗](http://yapi.cai-inc.com/project/3705/interface/api/526250) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/bind-fee-item`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
export interface ZlbCostControlBdStandardBindFeeItemPostRequest {
  /**
   * 系统单据的费用项
   */
  feeItemCode: string;
  /**
   * 绑定的费用项规则编码
   */
  feeItemConfigCode: string;
  /**
   * 费用标准类型，1系统 2租户 3机构
   */
  standardLevel: number;
  /**
   * 机构ID， level为3时必传
   */
  orgId?: number;
  /**
   * 租户code，level为2时必传
   */
  tenantCode?: string;
}

/**
 * 接口 [费用项规则绑定到机构\/租户下↗](http://yapi.cai-inc.com/project/3705/interface/api/526250) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/bind-fee-item`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
export interface ZlbCostControlBdStandardBindFeeItemPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费用项规则绑定到机构\/租户下↗](http://yapi.cai-inc.com/project/3705/interface/api/526250) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/bind-fee-item`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
type ZlbCostControlBdStandardBindFeeItemPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/standard/bind-fee-item',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [费用项规则绑定到机构\/租户下↗](http://yapi.cai-inc.com/project/3705/interface/api/526250) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/bind-fee-item`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
const zlbCostControlBdStandardBindFeeItemPostRequestConfig: ZlbCostControlBdStandardBindFeeItemPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/zlb/cost/control/bd/standard/bind-fee-item',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdStandardBindFeeItemPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费用项规则绑定到机构\/租户下↗](http://yapi.cai-inc.com/project/3705/interface/api/526250) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/bind-fee-item`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
export const zlbCostControlBdStandardBindFeeItemPost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdStandardBindFeeItemPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdStandardBindFeeItemPostResponse>(
    prepare(zlbCostControlBdStandardBindFeeItemPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdStandardBindFeeItemPost.requestConfig =
  zlbCostControlBdStandardBindFeeItemPostRequestConfig;

/**
 * 接口 [查询综合定额↗](http://yapi.cai-inc.com/project/3705/interface/api/545242) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/composite-detail`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
export interface ZlbCostControlBdStandardCompositeDetailPostRequest {
  /**
   * 是否继承上级配置(机构继承租户，租户继承通用)
   * 单据列表，费用项列表，总额定额详情接口使用
   */
  inherit?: boolean;
  /**
   * 费用标准类型，1系统 2租户 3机构
   */
  standardLevel: number;
  /**
   * 机构ID， level为3时必传
   */
  orgId?: number;
  /**
   * 租户code，level为2时必传
   */
  tenantCode?: string;
}

/**
 * 接口 [查询综合定额↗](http://yapi.cai-inc.com/project/3705/interface/api/545242) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/composite-detail`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
export interface ZlbCostControlBdStandardCompositeDetailPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 报销单类型
     */
    expenseFormType?: number;
    /**
     * 报销类型名称
     */
    expenseFormTypeName?: string;
    /**
     * 费用分类
     */
    feeTypeList?: {
      /**
       * 费用分类编码
       */
      feeTypeCode?: string;
      /**
       * 费用分类名称
       */
      feeTypeName?: string;
      /**
       * 费用项配置
       */
      feeItemInfoList?: {
        /**
         * 费用项编码
         */
        feeItemCode?: string;
        /**
         * 费用项名称
         */
        feeItemName?: string;
      }[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询综合定额↗](http://yapi.cai-inc.com/project/3705/interface/api/545242) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/composite-detail`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
type ZlbCostControlBdStandardCompositeDetailPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/standard/composite-detail',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询综合定额↗](http://yapi.cai-inc.com/project/3705/interface/api/545242) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/composite-detail`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
const zlbCostControlBdStandardCompositeDetailPostRequestConfig: ZlbCostControlBdStandardCompositeDetailPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/zlb/cost/control/bd/standard/composite-detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdStandardCompositeDetailPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询综合定额↗](http://yapi.cai-inc.com/project/3705/interface/api/545242) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/composite-detail`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
export const zlbCostControlBdStandardCompositeDetailPost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdStandardCompositeDetailPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdStandardCompositeDetailPostResponse>(
    prepare(zlbCostControlBdStandardCompositeDetailPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdStandardCompositeDetailPost.requestConfig =
  zlbCostControlBdStandardCompositeDetailPostRequestConfig;

/**
 * 接口 [保存综合定额↗](http://yapi.cai-inc.com/project/3705/interface/api/545250) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/save-composite`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
export interface ZlbCostControlBdStandardSaveCompositePostRequest {
  /**
   * 总额定额
   */
  compositeFeeItemList?: {
    /**
     * 报销单类型
     */
    expenseFormType?: number;
    /**
     * 报销类型名称
     */
    expenseFormTypeName?: string;
    /**
     * 费用分类
     */
    feeTypeList?: {
      /**
       * 费用分类编码
       */
      feeTypeCode?: string;
      /**
       * 费用分类名称
       */
      feeTypeName?: string;
      /**
       * 费用项配置
       */
      feeItemInfoList?: {
        /**
         * 费用项编码
         */
        feeItemCode?: string;
        /**
         * 费用项名称
         */
        feeItemName?: string;
      }[];
    }[];
  }[];
  /**
   * 费用标准类型，1系统 2租户 3机构
   */
  standardLevel: number;
  /**
   * 机构ID， level为3时必传
   */
  orgId?: number;
  /**
   * 租户code，level为2时必传
   */
  tenantCode?: string;
}

/**
 * 接口 [保存综合定额↗](http://yapi.cai-inc.com/project/3705/interface/api/545250) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/save-composite`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
export interface ZlbCostControlBdStandardSaveCompositePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存综合定额↗](http://yapi.cai-inc.com/project/3705/interface/api/545250) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/save-composite`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
type ZlbCostControlBdStandardSaveCompositePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/standard/save-composite',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存综合定额↗](http://yapi.cai-inc.com/project/3705/interface/api/545250) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/save-composite`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
const zlbCostControlBdStandardSaveCompositePostRequestConfig: ZlbCostControlBdStandardSaveCompositePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/zlb/cost/control/bd/standard/save-composite',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdStandardSaveCompositePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存综合定额↗](http://yapi.cai-inc.com/project/3705/interface/api/545250) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [新费用项标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53029)
 * @请求头 `POST /zlb/cost/control/bd/standard/save-composite`
 * @更新时间 `2023-10-11 10:11:01`
 * @项目ID 3705
 */
export const zlbCostControlBdStandardSaveCompositePost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdStandardSaveCompositePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdStandardSaveCompositePostResponse>(
    prepare(zlbCostControlBdStandardSaveCompositePostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdStandardSaveCompositePost.requestConfig =
  zlbCostControlBdStandardSaveCompositePostRequestConfig;

const mockUrl_0_0_0_3 = 'http://yapi.cai-inc.com/mock/3705' as any;
const devUrl_0_0_0_3 = '' as any;
const prodUrl_0_0_0_3 = '' as any;
const dataKey_0_0_0_3 = 'data' as any;

/**
 * 接口 [数据组分类列表↗](http://yapi.cai-inc.com/project/3705/interface/api/544218) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/category-list`
 * @更新时间 `2023-10-09 11:20:26`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataCategoryListGetRequest {
  groupCategoryName?: string;
}

/**
 * 接口 [数据组分类列表↗](http://yapi.cai-inc.com/project/3705/interface/api/544218) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/category-list`
 * @更新时间 `2023-10-09 11:20:26`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataCategoryListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 数据组分类编码
     */
    groupCategoryCode?: string;
    /**
     * 数据组分类名称
     */
    groupCategoryName?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [数据组分类列表↗](http://yapi.cai-inc.com/project/3705/interface/api/544218) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/category-list`
 * @更新时间 `2023-10-09 11:20:26`
 * @项目ID 3705
 */
type ZlbCostControlBdBasicDataCategoryListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/basic-data/category-list',
    'data',
    string,
    'groupCategoryName',
    false
  >
>;

/**
 * 接口 [数据组分类列表↗](http://yapi.cai-inc.com/project/3705/interface/api/544218) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/category-list`
 * @更新时间 `2023-10-09 11:20:26`
 * @项目ID 3705
 */
const zlbCostControlBdBasicDataCategoryListGetRequestConfig: ZlbCostControlBdBasicDataCategoryListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/zlb/cost/control/bd/basic-data/category-list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: ['groupCategoryName'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdBasicDataCategoryListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [数据组分类列表↗](http://yapi.cai-inc.com/project/3705/interface/api/544218) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/category-list`
 * @更新时间 `2023-10-09 11:20:26`
 * @项目ID 3705
 */
export const zlbCostControlBdBasicDataCategoryListGet = /*#__PURE__*/ (
  requestData: ZlbCostControlBdBasicDataCategoryListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdBasicDataCategoryListGetResponse>(
    prepare(zlbCostControlBdBasicDataCategoryListGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdBasicDataCategoryListGet.requestConfig =
  zlbCostControlBdBasicDataCategoryListGetRequestConfig;

/**
 * 接口 [数据组分类详情↗](http://yapi.cai-inc.com/project/3705/interface/api/544226) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/category-detail/{groupCategoryCode}`
 * @更新时间 `2023-10-09 11:20:26`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataCategoryDetailGroupCategoryCodeGetRequest {
  groupCategoryCode: string;
}

/**
 * 接口 [数据组分类详情↗](http://yapi.cai-inc.com/project/3705/interface/api/544226) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/category-detail/{groupCategoryCode}`
 * @更新时间 `2023-10-09 11:20:26`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataCategoryDetailGroupCategoryCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 数据组分类编码
     */
    groupCategoryCode?: string;
    /**
     * 数据组分类名称
     */
    groupCategoryName?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [数据组分类详情↗](http://yapi.cai-inc.com/project/3705/interface/api/544226) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/category-detail/{groupCategoryCode}`
 * @更新时间 `2023-10-09 11:20:26`
 * @项目ID 3705
 */
type ZlbCostControlBdBasicDataCategoryDetailGroupCategoryCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/basic-data/category-detail/{groupCategoryCode}',
    'data',
    'groupCategoryCode',
    string,
    false
  >
>;

/**
 * 接口 [数据组分类详情↗](http://yapi.cai-inc.com/project/3705/interface/api/544226) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/category-detail/{groupCategoryCode}`
 * @更新时间 `2023-10-09 11:20:26`
 * @项目ID 3705
 */
const zlbCostControlBdBasicDataCategoryDetailGroupCategoryCodeGetRequestConfig: ZlbCostControlBdBasicDataCategoryDetailGroupCategoryCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/zlb/cost/control/bd/basic-data/category-detail/{groupCategoryCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: ['groupCategoryCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdBasicDataCategoryDetailGroupCategoryCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [数据组分类详情↗](http://yapi.cai-inc.com/project/3705/interface/api/544226) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/category-detail/{groupCategoryCode}`
 * @更新时间 `2023-10-09 11:20:26`
 * @项目ID 3705
 */
export const zlbCostControlBdBasicDataCategoryDetailGroupCategoryCodeGet = /*#__PURE__*/ (
  requestData: ZlbCostControlBdBasicDataCategoryDetailGroupCategoryCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdBasicDataCategoryDetailGroupCategoryCodeGetResponse>(
    prepare(zlbCostControlBdBasicDataCategoryDetailGroupCategoryCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdBasicDataCategoryDetailGroupCategoryCodeGet.requestConfig =
  zlbCostControlBdBasicDataCategoryDetailGroupCategoryCodeGetRequestConfig;

/**
 * 接口 [数据组分类保存↗](http://yapi.cai-inc.com/project/3705/interface/api/544234) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/save-category`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataSaveCategoryPostRequest {
  /**
   * 数据组分类编码
   */
  groupCategoryCode?: string;
  /**
   * 数据组分类名称
   */
  groupCategoryName: string;
}

/**
 * 接口 [数据组分类保存↗](http://yapi.cai-inc.com/project/3705/interface/api/544234) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/save-category`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataSaveCategoryPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [数据组分类保存↗](http://yapi.cai-inc.com/project/3705/interface/api/544234) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/save-category`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
type ZlbCostControlBdBasicDataSaveCategoryPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/basic-data/save-category',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [数据组分类保存↗](http://yapi.cai-inc.com/project/3705/interface/api/544234) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/save-category`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
const zlbCostControlBdBasicDataSaveCategoryPostRequestConfig: ZlbCostControlBdBasicDataSaveCategoryPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/zlb/cost/control/bd/basic-data/save-category',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdBasicDataSaveCategoryPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [数据组分类保存↗](http://yapi.cai-inc.com/project/3705/interface/api/544234) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/save-category`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
export const zlbCostControlBdBasicDataSaveCategoryPost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdBasicDataSaveCategoryPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdBasicDataSaveCategoryPostResponse>(
    prepare(zlbCostControlBdBasicDataSaveCategoryPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdBasicDataSaveCategoryPost.requestConfig =
  zlbCostControlBdBasicDataSaveCategoryPostRequestConfig;

/**
 * 接口 [校验数据组分类是否可删除，可删除为true,不可删除为FALSE↗](http://yapi.cai-inc.com/project/3705/interface/api/544242) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/check-delete-category/{groupCategoryCode}`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataCheckDeleteCategoryGroupCategoryCodeGetRequest {
  groupCategoryCode: string;
}

/**
 * 接口 [校验数据组分类是否可删除，可删除为true,不可删除为FALSE↗](http://yapi.cai-inc.com/project/3705/interface/api/544242) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/check-delete-category/{groupCategoryCode}`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataCheckDeleteCategoryGroupCategoryCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [校验数据组分类是否可删除，可删除为true,不可删除为FALSE↗](http://yapi.cai-inc.com/project/3705/interface/api/544242) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/check-delete-category/{groupCategoryCode}`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
type ZlbCostControlBdBasicDataCheckDeleteCategoryGroupCategoryCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/basic-data/check-delete-category/{groupCategoryCode}',
    'data',
    'groupCategoryCode',
    string,
    false
  >
>;

/**
 * 接口 [校验数据组分类是否可删除，可删除为true,不可删除为FALSE↗](http://yapi.cai-inc.com/project/3705/interface/api/544242) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/check-delete-category/{groupCategoryCode}`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
const zlbCostControlBdBasicDataCheckDeleteCategoryGroupCategoryCodeGetRequestConfig: ZlbCostControlBdBasicDataCheckDeleteCategoryGroupCategoryCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/zlb/cost/control/bd/basic-data/check-delete-category/{groupCategoryCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: ['groupCategoryCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdBasicDataCheckDeleteCategoryGroupCategoryCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [校验数据组分类是否可删除，可删除为true,不可删除为FALSE↗](http://yapi.cai-inc.com/project/3705/interface/api/544242) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/check-delete-category/{groupCategoryCode}`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
export const zlbCostControlBdBasicDataCheckDeleteCategoryGroupCategoryCodeGet = /*#__PURE__*/ (
  requestData: ZlbCostControlBdBasicDataCheckDeleteCategoryGroupCategoryCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdBasicDataCheckDeleteCategoryGroupCategoryCodeGetResponse>(
    prepare(
      zlbCostControlBdBasicDataCheckDeleteCategoryGroupCategoryCodeGetRequestConfig,
      requestData,
    ),
    ...args,
  );
};

zlbCostControlBdBasicDataCheckDeleteCategoryGroupCategoryCodeGet.requestConfig =
  zlbCostControlBdBasicDataCheckDeleteCategoryGroupCategoryCodeGetRequestConfig;

/**
 * 接口 [删除数据组分类↗](http://yapi.cai-inc.com/project/3705/interface/api/544250) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/delete-category/{categoryCode}`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataDeleteCategoryCategoryCodePostRequest {
  categoryCode: string;
}

/**
 * 接口 [删除数据组分类↗](http://yapi.cai-inc.com/project/3705/interface/api/544250) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/delete-category/{categoryCode}`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataDeleteCategoryCategoryCodePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除数据组分类↗](http://yapi.cai-inc.com/project/3705/interface/api/544250) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/delete-category/{categoryCode}`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
type ZlbCostControlBdBasicDataDeleteCategoryCategoryCodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/basic-data/delete-category/{categoryCode}',
    'data',
    'categoryCode',
    string,
    false
  >
>;

/**
 * 接口 [删除数据组分类↗](http://yapi.cai-inc.com/project/3705/interface/api/544250) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/delete-category/{categoryCode}`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
const zlbCostControlBdBasicDataDeleteCategoryCategoryCodePostRequestConfig: ZlbCostControlBdBasicDataDeleteCategoryCategoryCodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/zlb/cost/control/bd/basic-data/delete-category/{categoryCode}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: ['categoryCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdBasicDataDeleteCategoryCategoryCodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除数据组分类↗](http://yapi.cai-inc.com/project/3705/interface/api/544250) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/delete-category/{categoryCode}`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
export const zlbCostControlBdBasicDataDeleteCategoryCategoryCodePost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdBasicDataDeleteCategoryCategoryCodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdBasicDataDeleteCategoryCategoryCodePostResponse>(
    prepare(zlbCostControlBdBasicDataDeleteCategoryCategoryCodePostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdBasicDataDeleteCategoryCategoryCodePost.requestConfig =
  zlbCostControlBdBasicDataDeleteCategoryCategoryCodePostRequestConfig;

/**
 * 接口 [基础数据组分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/544258) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/data-group-page`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataDataGroupPagePostRequest {
  /**
   * 分类编码
   */
  groupCategoryCode?: string;
  /**
   * 分组名称，模糊搜索
   */
  groupName?: string;
  /**
   * 关联数据编码
   */
  relationGroupCode?: string;
  /**
   * 状态 0停用 1启用
   */
  status?: number;
  type?: number;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [基础数据组分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/544258) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/data-group-page`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataDataGroupPagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 数据组分类编码
       */
      groupCategoryCode: string;
      /**
       * 数据组编码
       */
      groupCode?: string;
      /**
       * 数据组名称
       */
      groupName: string;
      /**
       * 状态
       */
      status?: number;
      /**
       * 状态描述
       */
      statusDesc?: string;
      /**
       * 0系统级 1手动创建
       */
      type?: number;
      /**
       * 类型描述
       */
      typeDesc?: string;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [基础数据组分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/544258) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/data-group-page`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
type ZlbCostControlBdBasicDataDataGroupPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/basic-data/data-group-page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [基础数据组分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/544258) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/data-group-page`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
const zlbCostControlBdBasicDataDataGroupPagePostRequestConfig: ZlbCostControlBdBasicDataDataGroupPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/zlb/cost/control/bd/basic-data/data-group-page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdBasicDataDataGroupPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [基础数据组分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/544258) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/data-group-page`
 * @更新时间 `2023-10-09 11:20:27`
 * @项目ID 3705
 */
export const zlbCostControlBdBasicDataDataGroupPagePost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdBasicDataDataGroupPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdBasicDataDataGroupPagePostResponse>(
    prepare(zlbCostControlBdBasicDataDataGroupPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdBasicDataDataGroupPagePost.requestConfig =
  zlbCostControlBdBasicDataDataGroupPagePostRequestConfig;

/**
 * 接口 [基础数据组列表↗](http://yapi.cai-inc.com/project/3705/interface/api/544266) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/data-group-list`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataDataGroupListPostRequest {
  /**
   * 数据组名称
   */
  groupName?: string;
  /**
   * 分类code
   */
  groupCategoryCode: string;
  /**
   * 类型 0系统预设 1手动新增
   */
  type?: number;
}

/**
 * 接口 [基础数据组列表↗](http://yapi.cai-inc.com/project/3705/interface/api/544266) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/data-group-list`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataDataGroupListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 数据组分类编码
     */
    groupCategoryCode: string;
    /**
     * 数据组编码
     */
    groupCode?: string;
    /**
     * 数据组名称
     */
    groupName: string;
    /**
     * 状态
     */
    status?: number;
    /**
     * 状态描述
     */
    statusDesc?: string;
    /**
     * 0系统级 1手动创建
     */
    type?: number;
    /**
     * 类型描述
     */
    typeDesc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [基础数据组列表↗](http://yapi.cai-inc.com/project/3705/interface/api/544266) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/data-group-list`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
type ZlbCostControlBdBasicDataDataGroupListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/basic-data/data-group-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [基础数据组列表↗](http://yapi.cai-inc.com/project/3705/interface/api/544266) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/data-group-list`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
const zlbCostControlBdBasicDataDataGroupListPostRequestConfig: ZlbCostControlBdBasicDataDataGroupListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/zlb/cost/control/bd/basic-data/data-group-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdBasicDataDataGroupListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [基础数据组列表↗](http://yapi.cai-inc.com/project/3705/interface/api/544266) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/data-group-list`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
export const zlbCostControlBdBasicDataDataGroupListPost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdBasicDataDataGroupListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdBasicDataDataGroupListPostResponse>(
    prepare(zlbCostControlBdBasicDataDataGroupListPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdBasicDataDataGroupListPost.requestConfig =
  zlbCostControlBdBasicDataDataGroupListPostRequestConfig;

/**
 * 接口 [基础数据组详情↗](http://yapi.cai-inc.com/project/3705/interface/api/544274) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/data-group-detail/{groupCode}`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataDataGroupDetailGroupCodeGetRequest {
  groupCode: string;
}

/**
 * 接口 [基础数据组详情↗](http://yapi.cai-inc.com/project/3705/interface/api/544274) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/data-group-detail/{groupCode}`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataDataGroupDetailGroupCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 数据字段配置
     */
    basicDataList?: {
      /**
       * 数据编码
       */
      dataCode?: string;
      /**
       * 数据名称
       */
      dataName?: string;
      /**
       * 数据组编码
       */
      groupCode?: string;
      /**
       * 是否关联了系统数据
       */
      related?: boolean;
      /**
       * 关联系统默认数据组编码
       */
      relatedGroupCode?: string;
      /**
       * 关联的系统数据编码
       */
      relatedDataCode?: string;
      /**
       * 关联的系统数据名称
       */
      relatedDataName?: string;
    }[];
    /**
     * 数据组分类编码
     */
    groupCategoryCode: string;
    /**
     * 数据组编码
     */
    groupCode?: string;
    /**
     * 数据组名称
     */
    groupName: string;
    /**
     * 状态
     */
    status?: number;
    /**
     * 状态描述
     */
    statusDesc?: string;
    /**
     * 0系统级 1手动创建
     */
    type?: number;
    /**
     * 类型描述
     */
    typeDesc?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [基础数据组详情↗](http://yapi.cai-inc.com/project/3705/interface/api/544274) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/data-group-detail/{groupCode}`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
type ZlbCostControlBdBasicDataDataGroupDetailGroupCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/basic-data/data-group-detail/{groupCode}',
    'data',
    'groupCode',
    string,
    false
  >
>;

/**
 * 接口 [基础数据组详情↗](http://yapi.cai-inc.com/project/3705/interface/api/544274) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/data-group-detail/{groupCode}`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
const zlbCostControlBdBasicDataDataGroupDetailGroupCodeGetRequestConfig: ZlbCostControlBdBasicDataDataGroupDetailGroupCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/zlb/cost/control/bd/basic-data/data-group-detail/{groupCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: ['groupCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdBasicDataDataGroupDetailGroupCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [基础数据组详情↗](http://yapi.cai-inc.com/project/3705/interface/api/544274) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `GET /zlb/cost/control/bd/basic-data/data-group-detail/{groupCode}`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
export const zlbCostControlBdBasicDataDataGroupDetailGroupCodeGet = /*#__PURE__*/ (
  requestData: ZlbCostControlBdBasicDataDataGroupDetailGroupCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdBasicDataDataGroupDetailGroupCodeGetResponse>(
    prepare(zlbCostControlBdBasicDataDataGroupDetailGroupCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdBasicDataDataGroupDetailGroupCodeGet.requestConfig =
  zlbCostControlBdBasicDataDataGroupDetailGroupCodeGetRequestConfig;

/**
 * 接口 [基础数据组保存↗](http://yapi.cai-inc.com/project/3705/interface/api/544282) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/save-data-group`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataSaveDataGroupPostRequest {
  /**
   * 字段配置
   */
  basicDataList?: {
    /**
     * 数据编码
     */
    dataCode?: string;
    /**
     * 数据名称
     */
    dataName?: string;
    /**
     * 数据组编码
     */
    groupCode?: string;
    /**
     * 是否关联了系统数据
     */
    related?: boolean;
    /**
     * 关联系统默认数据组编码
     */
    relatedGroupCode?: string;
    /**
     * 关联的系统数据编码
     */
    relatedDataCode?: string;
    /**
     * 关联的系统数据名称
     */
    relatedDataName?: string;
  }[];
  /**
   * 数据组分类编码
   */
  groupCategoryCode: string;
  /**
   * 数据组编码
   */
  groupCode?: string;
  /**
   * 数据组名称
   */
  groupName: string;
  /**
   * 状态
   */
  status?: number;
  /**
   * 状态描述
   */
  statusDesc?: string;
  /**
   * 0系统级 1手动创建
   */
  type?: number;
  /**
   * 类型描述
   */
  typeDesc?: string;
}

/**
 * 接口 [基础数据组保存↗](http://yapi.cai-inc.com/project/3705/interface/api/544282) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/save-data-group`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataSaveDataGroupPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [基础数据组保存↗](http://yapi.cai-inc.com/project/3705/interface/api/544282) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/save-data-group`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
type ZlbCostControlBdBasicDataSaveDataGroupPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/basic-data/save-data-group',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [基础数据组保存↗](http://yapi.cai-inc.com/project/3705/interface/api/544282) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/save-data-group`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
const zlbCostControlBdBasicDataSaveDataGroupPostRequestConfig: ZlbCostControlBdBasicDataSaveDataGroupPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/zlb/cost/control/bd/basic-data/save-data-group',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdBasicDataSaveDataGroupPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [基础数据组保存↗](http://yapi.cai-inc.com/project/3705/interface/api/544282) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/save-data-group`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
export const zlbCostControlBdBasicDataSaveDataGroupPost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdBasicDataSaveDataGroupPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdBasicDataSaveDataGroupPostResponse>(
    prepare(zlbCostControlBdBasicDataSaveDataGroupPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdBasicDataSaveDataGroupPost.requestConfig =
  zlbCostControlBdBasicDataSaveDataGroupPostRequestConfig;

/**
 * 接口 [基础数据停启用↗](http://yapi.cai-inc.com/project/3705/interface/api/544290) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/change-group-status`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataChangeGroupStatusPostRequest {
  /**
   * 基础数据组编码
   */
  groupCode: string;
  /**
   * 修改后的状态
   */
  status: number;
}

/**
 * 接口 [基础数据停启用↗](http://yapi.cai-inc.com/project/3705/interface/api/544290) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/change-group-status`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataChangeGroupStatusPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [基础数据停启用↗](http://yapi.cai-inc.com/project/3705/interface/api/544290) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/change-group-status`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
type ZlbCostControlBdBasicDataChangeGroupStatusPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/basic-data/change-group-status',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [基础数据停启用↗](http://yapi.cai-inc.com/project/3705/interface/api/544290) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/change-group-status`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
const zlbCostControlBdBasicDataChangeGroupStatusPostRequestConfig: ZlbCostControlBdBasicDataChangeGroupStatusPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/zlb/cost/control/bd/basic-data/change-group-status',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdBasicDataChangeGroupStatusPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [基础数据停启用↗](http://yapi.cai-inc.com/project/3705/interface/api/544290) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/change-group-status`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
export const zlbCostControlBdBasicDataChangeGroupStatusPost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdBasicDataChangeGroupStatusPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdBasicDataChangeGroupStatusPostResponse>(
    prepare(zlbCostControlBdBasicDataChangeGroupStatusPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdBasicDataChangeGroupStatusPost.requestConfig =
  zlbCostControlBdBasicDataChangeGroupStatusPostRequestConfig;

/**
 * 接口 [基础数据删除↗](http://yapi.cai-inc.com/project/3705/interface/api/544298) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/delete-group/{groupCode}`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataDeleteGroupGroupCodePostRequest {
  groupCode: string;
}

/**
 * 接口 [基础数据删除↗](http://yapi.cai-inc.com/project/3705/interface/api/544298) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/delete-group/{groupCode}`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
export interface ZlbCostControlBdBasicDataDeleteGroupGroupCodePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [基础数据删除↗](http://yapi.cai-inc.com/project/3705/interface/api/544298) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/delete-group/{groupCode}`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
type ZlbCostControlBdBasicDataDeleteGroupGroupCodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/basic-data/delete-group/{groupCode}',
    'data',
    'groupCode',
    string,
    false
  >
>;

/**
 * 接口 [基础数据删除↗](http://yapi.cai-inc.com/project/3705/interface/api/544298) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/delete-group/{groupCode}`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
const zlbCostControlBdBasicDataDeleteGroupGroupCodePostRequestConfig: ZlbCostControlBdBasicDataDeleteGroupGroupCodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/zlb/cost/control/bd/basic-data/delete-group/{groupCode}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: ['groupCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdBasicDataDeleteGroupGroupCodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [基础数据删除↗](http://yapi.cai-inc.com/project/3705/interface/api/544298) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [基础数据↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53361)
 * @请求头 `POST /zlb/cost/control/bd/basic-data/delete-group/{groupCode}`
 * @更新时间 `2023-10-09 11:20:28`
 * @项目ID 3705
 */
export const zlbCostControlBdBasicDataDeleteGroupGroupCodePost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdBasicDataDeleteGroupGroupCodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdBasicDataDeleteGroupGroupCodePostResponse>(
    prepare(zlbCostControlBdBasicDataDeleteGroupGroupCodePostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdBasicDataDeleteGroupGroupCodePost.requestConfig =
  zlbCostControlBdBasicDataDeleteGroupGroupCodePostRequestConfig;

const mockUrl_0_0_0_4 = 'http://yapi.cai-inc.com/mock/3705' as any;
const devUrl_0_0_0_4 = '' as any;
const prodUrl_0_0_0_4 = '' as any;
const dataKey_0_0_0_4 = 'data' as any;

/**
 * 接口 [费用项规则保存↗](http://yapi.cai-inc.com/project/3705/interface/api/545162) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53383)
 * @请求头 `POST /zlb/cost/control/bd/fee-item-config/save`
 * @更新时间 `2023-10-10 20:47:42`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemConfigSavePostRequest {
  /**
   * 费用规则编码
   */
  itemConfigCode?: string;
  /**
   * 报销单类型编码
   */
  formTypeCode: string;
  /**
   * 费用项编码
   */
  feeItemCode: string;
  /**
   * 费用生成方式
   */
  generateType: 1 | 2;
  /**
   * 费用控制方式
   */
  controlType: 1 | 2;
  /**
   * 强弱控控制方式
   */
  checkType: 1 | 2 | 3 | 4 | 5;
  /**
   * 配置信息
   */
  extendData: {
    /**
     * 金额标准
     */
    amount: number;
    /**
     * 单位
     */
    unit: 1 | 2 | 3;
  };
}

/**
 * 接口 [费用项规则保存↗](http://yapi.cai-inc.com/project/3705/interface/api/545162) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53383)
 * @请求头 `POST /zlb/cost/control/bd/fee-item-config/save`
 * @更新时间 `2023-10-10 20:47:42`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemConfigSavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费用项规则保存↗](http://yapi.cai-inc.com/project/3705/interface/api/545162) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53383)
 * @请求头 `POST /zlb/cost/control/bd/fee-item-config/save`
 * @更新时间 `2023-10-10 20:47:42`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemConfigSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item-config/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [费用项规则保存↗](http://yapi.cai-inc.com/project/3705/interface/api/545162) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53383)
 * @请求头 `POST /zlb/cost/control/bd/fee-item-config/save`
 * @更新时间 `2023-10-10 20:47:42`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemConfigSavePostRequestConfig: ZlbCostControlBdFeeItemConfigSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: '/zlb/cost/control/bd/fee-item-config/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemConfigSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费用项规则保存↗](http://yapi.cai-inc.com/project/3705/interface/api/545162) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53383)
 * @请求头 `POST /zlb/cost/control/bd/fee-item-config/save`
 * @更新时间 `2023-10-10 20:47:42`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemConfigSavePost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemConfigSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemConfigSavePostResponse>(
    prepare(zlbCostControlBdFeeItemConfigSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemConfigSavePost.requestConfig =
  zlbCostControlBdFeeItemConfigSavePostRequestConfig;

/**
 * 接口 [费用项规则停启用↗](http://yapi.cai-inc.com/project/3705/interface/api/545170) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53383)
 * @请求头 `POST /zlb/cost/control/bd/fee-item-config/change-status`
 * @更新时间 `2023-10-08 17:37:27`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemConfigChangeStatusPostRequest {
  /**
   * 费用项规则编码
   */
  itemConfigCode: string;
  /**
   * 修改后的状态
   */
  status: number;
}

/**
 * 接口 [费用项规则停启用↗](http://yapi.cai-inc.com/project/3705/interface/api/545170) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53383)
 * @请求头 `POST /zlb/cost/control/bd/fee-item-config/change-status`
 * @更新时间 `2023-10-08 17:37:27`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemConfigChangeStatusPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费用项规则停启用↗](http://yapi.cai-inc.com/project/3705/interface/api/545170) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53383)
 * @请求头 `POST /zlb/cost/control/bd/fee-item-config/change-status`
 * @更新时间 `2023-10-08 17:37:27`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemConfigChangeStatusPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item-config/change-status',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [费用项规则停启用↗](http://yapi.cai-inc.com/project/3705/interface/api/545170) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53383)
 * @请求头 `POST /zlb/cost/control/bd/fee-item-config/change-status`
 * @更新时间 `2023-10-08 17:37:27`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemConfigChangeStatusPostRequestConfig: ZlbCostControlBdFeeItemConfigChangeStatusPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: '/zlb/cost/control/bd/fee-item-config/change-status',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemConfigChangeStatusPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费用项规则停启用↗](http://yapi.cai-inc.com/project/3705/interface/api/545170) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53383)
 * @请求头 `POST /zlb/cost/control/bd/fee-item-config/change-status`
 * @更新时间 `2023-10-08 17:37:27`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemConfigChangeStatusPost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemConfigChangeStatusPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemConfigChangeStatusPostResponse>(
    prepare(zlbCostControlBdFeeItemConfigChangeStatusPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemConfigChangeStatusPost.requestConfig =
  zlbCostControlBdFeeItemConfigChangeStatusPostRequestConfig;

/**
 * 接口 [费用项规则详情↗](http://yapi.cai-inc.com/project/3705/interface/api/545586) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53383)
 * @请求头 `POST /zlb/cost/control/bd/fee-item-config/detail`
 * @更新时间 `2023-10-08 17:37:26`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemConfigDetailPostRequest {
  /**
   * 单据类型编码
   */
  formTypeCode: string;
  /**
   * 费用项编码
   */
  feeItemCode: string;
}

/**
 * 接口 [费用项规则详情↗](http://yapi.cai-inc.com/project/3705/interface/api/545586) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53383)
 * @请求头 `POST /zlb/cost/control/bd/fee-item-config/detail`
 * @更新时间 `2023-10-08 17:37:26`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemConfigDetailPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 费用规则编码
     */
    itemConfigCode?: string;
    /**
     * 报销单类型编码
     */
    formTypeCode?: string;
    /**
     * 费用项编码
     */
    feeItemCode?: string;
    /**
     * 费用项名称
     */
    feeItemName?: string;
    /**
     * 费用生成方式
     */
    generateType?: number;
    /**
     * 费用生成方式描述
     */
    generateTypeDesc?: string;
    /**
     * 费用控制方式
     */
    controlType?: number;
    /**
     * 费用控制方式描述
     */
    controlTypeDesc?: string;
    /**
     * 强弱控控制方式
     */
    checkType?: number;
    /**
     * 强弱控控制方式描述
     */
    checkTypeDesc?: string;
    /**
     * 配置信息
     */
    extendData?: {
      /**
       * 金额标准
       */
      amount?: number;
      /**
       * 单位
       */
      unit?: 1 | 2 | 3;
      /**
       * 单位描述
       */
      unitDesc?: string;
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费用项规则详情↗](http://yapi.cai-inc.com/project/3705/interface/api/545586) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53383)
 * @请求头 `POST /zlb/cost/control/bd/fee-item-config/detail`
 * @更新时间 `2023-10-08 17:37:26`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemConfigDetailPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item-config/detail',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [费用项规则详情↗](http://yapi.cai-inc.com/project/3705/interface/api/545586) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53383)
 * @请求头 `POST /zlb/cost/control/bd/fee-item-config/detail`
 * @更新时间 `2023-10-08 17:37:26`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemConfigDetailPostRequestConfig: ZlbCostControlBdFeeItemConfigDetailPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: '/zlb/cost/control/bd/fee-item-config/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemConfigDetailPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费用项规则详情↗](http://yapi.cai-inc.com/project/3705/interface/api/545586) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项规则↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53383)
 * @请求头 `POST /zlb/cost/control/bd/fee-item-config/detail`
 * @更新时间 `2023-10-08 17:37:26`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemConfigDetailPost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemConfigDetailPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemConfigDetailPostResponse>(
    prepare(zlbCostControlBdFeeItemConfigDetailPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemConfigDetailPost.requestConfig =
  zlbCostControlBdFeeItemConfigDetailPostRequestConfig;

const mockUrl_0_0_0_5 = 'http://yapi.cai-inc.com/mock/3705' as any;
const devUrl_0_0_0_5 = '' as any;
const prodUrl_0_0_0_5 = '' as any;
const dataKey_0_0_0_5 = 'data' as any;

/**
 * 接口 [费用项分类列表↗](http://yapi.cai-inc.com/project/3705/interface/api/547026) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/category-list`
 * @更新时间 `2023-10-10 17:52:55`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemCategoryListGetRequest {
  categoryName?: string;
}

/**
 * 接口 [费用项分类列表↗](http://yapi.cai-inc.com/project/3705/interface/api/547026) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/category-list`
 * @更新时间 `2023-10-10 17:52:55`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemCategoryListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 费用分类编码
     */
    feeItemCategoryCode?: string;
    /**
     * 费用分类名称
     */
    feeItemCategoryName?: string;
    /**
     * 备注
     */
    remark?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费用项分类列表↗](http://yapi.cai-inc.com/project/3705/interface/api/547026) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/category-list`
 * @更新时间 `2023-10-10 17:52:55`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemCategoryListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item/category-list',
    'data',
    string,
    'categoryName',
    false
  >
>;

/**
 * 接口 [费用项分类列表↗](http://yapi.cai-inc.com/project/3705/interface/api/547026) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/category-list`
 * @更新时间 `2023-10-10 17:52:55`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemCategoryListGetRequestConfig: ZlbCostControlBdFeeItemCategoryListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/zlb/cost/control/bd/fee-item/category-list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: ['categoryName'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemCategoryListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费用项分类列表↗](http://yapi.cai-inc.com/project/3705/interface/api/547026) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/category-list`
 * @更新时间 `2023-10-10 17:52:55`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemCategoryListGet = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemCategoryListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemCategoryListGetResponse>(
    prepare(zlbCostControlBdFeeItemCategoryListGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemCategoryListGet.requestConfig =
  zlbCostControlBdFeeItemCategoryListGetRequestConfig;

/**
 * 接口 [费用项分类详情↗](http://yapi.cai-inc.com/project/3705/interface/api/547034) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/category-detail/{feeItemCategoryCode}`
 * @更新时间 `2023-10-10 17:52:55`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemCategoryDetailFeeItemCategoryCodeGetRequest {
  feeItemCategoryCode: string;
}

/**
 * 接口 [费用项分类详情↗](http://yapi.cai-inc.com/project/3705/interface/api/547034) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/category-detail/{feeItemCategoryCode}`
 * @更新时间 `2023-10-10 17:52:55`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemCategoryDetailFeeItemCategoryCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 费用分类编码
     */
    feeItemCategoryCode?: string;
    /**
     * 费用分类名称
     */
    feeItemCategoryName?: string;
    /**
     * 备注
     */
    remark?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费用项分类详情↗](http://yapi.cai-inc.com/project/3705/interface/api/547034) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/category-detail/{feeItemCategoryCode}`
 * @更新时间 `2023-10-10 17:52:55`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemCategoryDetailFeeItemCategoryCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item/category-detail/{feeItemCategoryCode}',
    'data',
    'feeItemCategoryCode',
    string,
    false
  >
>;

/**
 * 接口 [费用项分类详情↗](http://yapi.cai-inc.com/project/3705/interface/api/547034) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/category-detail/{feeItemCategoryCode}`
 * @更新时间 `2023-10-10 17:52:55`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemCategoryDetailFeeItemCategoryCodeGetRequestConfig: ZlbCostControlBdFeeItemCategoryDetailFeeItemCategoryCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/zlb/cost/control/bd/fee-item/category-detail/{feeItemCategoryCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: ['feeItemCategoryCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemCategoryDetailFeeItemCategoryCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费用项分类详情↗](http://yapi.cai-inc.com/project/3705/interface/api/547034) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/category-detail/{feeItemCategoryCode}`
 * @更新时间 `2023-10-10 17:52:55`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemCategoryDetailFeeItemCategoryCodeGet = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemCategoryDetailFeeItemCategoryCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemCategoryDetailFeeItemCategoryCodeGetResponse>(
    prepare(zlbCostControlBdFeeItemCategoryDetailFeeItemCategoryCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemCategoryDetailFeeItemCategoryCodeGet.requestConfig =
  zlbCostControlBdFeeItemCategoryDetailFeeItemCategoryCodeGetRequestConfig;

/**
 * 接口 [费用项分类保存↗](http://yapi.cai-inc.com/project/3705/interface/api/547042) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/save-category`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemSaveCategoryPostRequest {
  /**
   * 费用分类编码
   */
  feeItemCategoryCode?: string;
  /**
   * 费用分类名称
   */
  feeItemCategoryName: string;
  /**
   * 备注
   */
  remark?: string;
}

/**
 * 接口 [费用项分类保存↗](http://yapi.cai-inc.com/project/3705/interface/api/547042) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/save-category`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemSaveCategoryPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费用项分类保存↗](http://yapi.cai-inc.com/project/3705/interface/api/547042) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/save-category`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemSaveCategoryPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item/save-category',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [费用项分类保存↗](http://yapi.cai-inc.com/project/3705/interface/api/547042) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/save-category`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemSaveCategoryPostRequestConfig: ZlbCostControlBdFeeItemSaveCategoryPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/zlb/cost/control/bd/fee-item/save-category',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemSaveCategoryPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费用项分类保存↗](http://yapi.cai-inc.com/project/3705/interface/api/547042) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/save-category`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemSaveCategoryPost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemSaveCategoryPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemSaveCategoryPostResponse>(
    prepare(zlbCostControlBdFeeItemSaveCategoryPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemSaveCategoryPost.requestConfig =
  zlbCostControlBdFeeItemSaveCategoryPostRequestConfig;

/**
 * 接口 [校验费用项分类是否可删除，可删除为true,不可删除为FALSE↗](http://yapi.cai-inc.com/project/3705/interface/api/547050) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/check-delete-category/{feeItemCategoryCode}`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemCheckDeleteCategoryFeeItemCategoryCodeGetRequest {
  feeItemCategoryCode: string;
}

/**
 * 接口 [校验费用项分类是否可删除，可删除为true,不可删除为FALSE↗](http://yapi.cai-inc.com/project/3705/interface/api/547050) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/check-delete-category/{feeItemCategoryCode}`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemCheckDeleteCategoryFeeItemCategoryCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [校验费用项分类是否可删除，可删除为true,不可删除为FALSE↗](http://yapi.cai-inc.com/project/3705/interface/api/547050) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/check-delete-category/{feeItemCategoryCode}`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemCheckDeleteCategoryFeeItemCategoryCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item/check-delete-category/{feeItemCategoryCode}',
    'data',
    'feeItemCategoryCode',
    string,
    false
  >
>;

/**
 * 接口 [校验费用项分类是否可删除，可删除为true,不可删除为FALSE↗](http://yapi.cai-inc.com/project/3705/interface/api/547050) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/check-delete-category/{feeItemCategoryCode}`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemCheckDeleteCategoryFeeItemCategoryCodeGetRequestConfig: ZlbCostControlBdFeeItemCheckDeleteCategoryFeeItemCategoryCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/zlb/cost/control/bd/fee-item/check-delete-category/{feeItemCategoryCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: ['feeItemCategoryCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemCheckDeleteCategoryFeeItemCategoryCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [校验费用项分类是否可删除，可删除为true,不可删除为FALSE↗](http://yapi.cai-inc.com/project/3705/interface/api/547050) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/check-delete-category/{feeItemCategoryCode}`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemCheckDeleteCategoryFeeItemCategoryCodeGet = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemCheckDeleteCategoryFeeItemCategoryCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemCheckDeleteCategoryFeeItemCategoryCodeGetResponse>(
    prepare(
      zlbCostControlBdFeeItemCheckDeleteCategoryFeeItemCategoryCodeGetRequestConfig,
      requestData,
    ),
    ...args,
  );
};

zlbCostControlBdFeeItemCheckDeleteCategoryFeeItemCategoryCodeGet.requestConfig =
  zlbCostControlBdFeeItemCheckDeleteCategoryFeeItemCategoryCodeGetRequestConfig;

/**
 * 接口 [删除费用项分类↗](http://yapi.cai-inc.com/project/3705/interface/api/547058) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/delete-category/{feeItemCategoryCode}`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemDeleteCategoryFeeItemCategoryCodePostRequest {
  feeItemCategoryCode: string;
}

/**
 * 接口 [删除费用项分类↗](http://yapi.cai-inc.com/project/3705/interface/api/547058) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/delete-category/{feeItemCategoryCode}`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemDeleteCategoryFeeItemCategoryCodePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除费用项分类↗](http://yapi.cai-inc.com/project/3705/interface/api/547058) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/delete-category/{feeItemCategoryCode}`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemDeleteCategoryFeeItemCategoryCodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item/delete-category/{feeItemCategoryCode}',
    'data',
    'feeItemCategoryCode',
    string,
    false
  >
>;

/**
 * 接口 [删除费用项分类↗](http://yapi.cai-inc.com/project/3705/interface/api/547058) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/delete-category/{feeItemCategoryCode}`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemDeleteCategoryFeeItemCategoryCodePostRequestConfig: ZlbCostControlBdFeeItemDeleteCategoryFeeItemCategoryCodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/zlb/cost/control/bd/fee-item/delete-category/{feeItemCategoryCode}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: ['feeItemCategoryCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemDeleteCategoryFeeItemCategoryCodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除费用项分类↗](http://yapi.cai-inc.com/project/3705/interface/api/547058) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/delete-category/{feeItemCategoryCode}`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemDeleteCategoryFeeItemCategoryCodePost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemDeleteCategoryFeeItemCategoryCodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemDeleteCategoryFeeItemCategoryCodePostResponse>(
    prepare(zlbCostControlBdFeeItemDeleteCategoryFeeItemCategoryCodePostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemDeleteCategoryFeeItemCategoryCodePost.requestConfig =
  zlbCostControlBdFeeItemDeleteCategoryFeeItemCategoryCodePostRequestConfig;

/**
 * 接口 [费用项分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/547066) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/fee-item-page`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemFeeItemPagePostRequest {
  /**
   * 费用分类编码
   */
  feeItemCategoryCode: string;
  /**
   * 费用项编码
   */
  feeItemCode?: string;
  /**
   * 费用项名称
   */
  feeItemName?: string;
  /**
   * 状态
   */
  status?: number;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 费用项编码列表,前端勿传
   */
  feeItemCodeList?: string[];
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [费用项分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/547066) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/fee-item-page`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemFeeItemPagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 状态描述
       */
      statusDesc?: string;
      /**
       * 费用项分类编码
       */
      feeItemCategoryCode: string;
      /**
       * 费用项编码
       */
      feeItemCode: string;
      /**
       * 费用项名称
       */
      feeItemName: string;
      /**
       * 状态
       */
      status: number;
      /**
       * 备注
       */
      remark?: string;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费用项分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/547066) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/fee-item-page`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemFeeItemPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item/fee-item-page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [费用项分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/547066) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/fee-item-page`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemFeeItemPagePostRequestConfig: ZlbCostControlBdFeeItemFeeItemPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/zlb/cost/control/bd/fee-item/fee-item-page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemFeeItemPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费用项分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/547066) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/fee-item-page`
 * @更新时间 `2023-10-10 17:52:56`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemFeeItemPagePost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemFeeItemPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemFeeItemPagePostResponse>(
    prepare(zlbCostControlBdFeeItemFeeItemPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemFeeItemPagePost.requestConfig =
  zlbCostControlBdFeeItemFeeItemPagePostRequestConfig;

/**
 * 接口 [费用项分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/547074) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/fee-item-list`
 * @更新时间 `2023-10-10 17:52:57`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemFeeItemListGetRequest {
  categoryCode?: string;
  feeItemName?: string;
}

/**
 * 接口 [费用项分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/547074) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/fee-item-list`
 * @更新时间 `2023-10-10 17:52:57`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemFeeItemListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 状态描述
     */
    statusDesc?: string;
    /**
     * 费用项分类编码
     */
    feeItemCategoryCode: string;
    /**
     * 费用项编码
     */
    feeItemCode: string;
    /**
     * 费用项名称
     */
    feeItemName: string;
    /**
     * 状态
     */
    status: number;
    /**
     * 备注
     */
    remark?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费用项分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/547074) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/fee-item-list`
 * @更新时间 `2023-10-10 17:52:57`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemFeeItemListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item/fee-item-list',
    'data',
    string,
    'categoryCode' | 'feeItemName',
    false
  >
>;

/**
 * 接口 [费用项分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/547074) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/fee-item-list`
 * @更新时间 `2023-10-10 17:52:57`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemFeeItemListGetRequestConfig: ZlbCostControlBdFeeItemFeeItemListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/zlb/cost/control/bd/fee-item/fee-item-list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: ['categoryCode', 'feeItemName'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemFeeItemListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费用项分页查询↗](http://yapi.cai-inc.com/project/3705/interface/api/547074) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/fee-item-list`
 * @更新时间 `2023-10-10 17:52:57`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemFeeItemListGet = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemFeeItemListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemFeeItemListGetResponse>(
    prepare(zlbCostControlBdFeeItemFeeItemListGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemFeeItemListGet.requestConfig =
  zlbCostControlBdFeeItemFeeItemListGetRequestConfig;

/**
 * 接口 [费用项详情↗](http://yapi.cai-inc.com/project/3705/interface/api/547082) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/fee-item-detail/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:57`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemFeeItemDetailFeeItemCodeGetRequest {
  feeItemCode: string;
}

/**
 * 接口 [费用项详情↗](http://yapi.cai-inc.com/project/3705/interface/api/547082) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/fee-item-detail/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:57`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemFeeItemDetailFeeItemCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 状态描述
     */
    statusDesc?: string;
    /**
     * 费用项分类编码
     */
    feeItemCategoryCode: string;
    /**
     * 费用项编码
     */
    feeItemCode: string;
    /**
     * 费用项名称
     */
    feeItemName: string;
    /**
     * 状态
     */
    status: number;
    /**
     * 备注
     */
    remark?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费用项详情↗](http://yapi.cai-inc.com/project/3705/interface/api/547082) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/fee-item-detail/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:57`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemFeeItemDetailFeeItemCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item/fee-item-detail/{feeItemCode}',
    'data',
    'feeItemCode',
    string,
    false
  >
>;

/**
 * 接口 [费用项详情↗](http://yapi.cai-inc.com/project/3705/interface/api/547082) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/fee-item-detail/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:57`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemFeeItemDetailFeeItemCodeGetRequestConfig: ZlbCostControlBdFeeItemFeeItemDetailFeeItemCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/zlb/cost/control/bd/fee-item/fee-item-detail/{feeItemCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: ['feeItemCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemFeeItemDetailFeeItemCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费用项详情↗](http://yapi.cai-inc.com/project/3705/interface/api/547082) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/fee-item-detail/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:57`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemFeeItemDetailFeeItemCodeGet = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemFeeItemDetailFeeItemCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemFeeItemDetailFeeItemCodeGetResponse>(
    prepare(zlbCostControlBdFeeItemFeeItemDetailFeeItemCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemFeeItemDetailFeeItemCodeGet.requestConfig =
  zlbCostControlBdFeeItemFeeItemDetailFeeItemCodeGetRequestConfig;

/**
 * 接口 [费用项字段配置详情↗](http://yapi.cai-inc.com/project/3705/interface/api/547090) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/fee-item-field/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:57`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemFeeItemFieldFeeItemCodeGetRequest {
  feeItemCode: string;
}

/**
 * 接口 [费用项字段配置详情↗](http://yapi.cai-inc.com/project/3705/interface/api/547090) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/fee-item-field/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:57`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemFeeItemFieldFeeItemCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 费用项编码
     */
    feeItemCode?: string;
    /**
     * 全量字段
     */
    fieldList?: {
      /**
       * 字段名称
       */
      fieldName?: string;
      /**
       * 是否已选中
       */
      chosen?: boolean;
      /**
       * 字段编码
       */
      fieldCode: string;
      /**
       * 是否必填
       */
      requiredStatus: boolean;
      /**
       * 排序
       */
      rank?: number;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费用项字段配置详情↗](http://yapi.cai-inc.com/project/3705/interface/api/547090) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/fee-item-field/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:57`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemFeeItemFieldFeeItemCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item/fee-item-field/{feeItemCode}',
    'data',
    'feeItemCode',
    string,
    false
  >
>;

/**
 * 接口 [费用项字段配置详情↗](http://yapi.cai-inc.com/project/3705/interface/api/547090) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/fee-item-field/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:57`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemFeeItemFieldFeeItemCodeGetRequestConfig: ZlbCostControlBdFeeItemFeeItemFieldFeeItemCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/zlb/cost/control/bd/fee-item/fee-item-field/{feeItemCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: ['feeItemCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemFeeItemFieldFeeItemCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费用项字段配置详情↗](http://yapi.cai-inc.com/project/3705/interface/api/547090) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/fee-item-field/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:57`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemFeeItemFieldFeeItemCodeGet = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemFeeItemFieldFeeItemCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemFeeItemFieldFeeItemCodeGetResponse>(
    prepare(zlbCostControlBdFeeItemFeeItemFieldFeeItemCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemFeeItemFieldFeeItemCodeGet.requestConfig =
  zlbCostControlBdFeeItemFeeItemFieldFeeItemCodeGetRequestConfig;

/**
 * 接口 [保存费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/547098) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/save-fee-item`
 * @更新时间 `2023-10-24 10:30:31`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemSaveFeeItemPostRequest {
  /**
   * 0新增 1修改
   */
  actionType?: 0 | 1;
  /**
   * 费用项分类编码
   */
  feeItemCategoryCode: string;
  /**
   * 费用项编码
   */
  feeItemCode?: string;
  /**
   * 费用项名称
   */
  feeItemName: string;
  /**
   * 状态
   */
  status: number;
  /**
   * 备注
   */
  remark?: string;
}

/**
 * 接口 [保存费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/547098) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/save-fee-item`
 * @更新时间 `2023-10-24 10:30:31`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemSaveFeeItemPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/547098) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/save-fee-item`
 * @更新时间 `2023-10-24 10:30:31`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemSaveFeeItemPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item/save-fee-item',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/547098) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/save-fee-item`
 * @更新时间 `2023-10-24 10:30:31`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemSaveFeeItemPostRequestConfig: ZlbCostControlBdFeeItemSaveFeeItemPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/zlb/cost/control/bd/fee-item/save-fee-item',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemSaveFeeItemPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/547098) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/save-fee-item`
 * @更新时间 `2023-10-24 10:30:31`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemSaveFeeItemPost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemSaveFeeItemPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemSaveFeeItemPostResponse>(
    prepare(zlbCostControlBdFeeItemSaveFeeItemPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemSaveFeeItemPost.requestConfig =
  zlbCostControlBdFeeItemSaveFeeItemPostRequestConfig;

/**
 * 接口 [保存费用项字段↗](http://yapi.cai-inc.com/project/3705/interface/api/547106) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/save-fee-item-field`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemSaveFeeItemFieldPostRequest {
  /**
   * 费用项编码
   */
  feeItemCode: string;
  /**
   * 选中的字段
   */
  feeItemFieldList?: {
    /**
     * 字段编码
     */
    fieldCode: string;
    /**
     * 是否必填
     */
    requiredStatus: boolean;
    /**
     * 排序
     */
    rank?: number;
  }[];
}

/**
 * 接口 [保存费用项字段↗](http://yapi.cai-inc.com/project/3705/interface/api/547106) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/save-fee-item-field`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemSaveFeeItemFieldPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存费用项字段↗](http://yapi.cai-inc.com/project/3705/interface/api/547106) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/save-fee-item-field`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemSaveFeeItemFieldPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item/save-fee-item-field',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存费用项字段↗](http://yapi.cai-inc.com/project/3705/interface/api/547106) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/save-fee-item-field`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemSaveFeeItemFieldPostRequestConfig: ZlbCostControlBdFeeItemSaveFeeItemFieldPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/zlb/cost/control/bd/fee-item/save-fee-item-field',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemSaveFeeItemFieldPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存费用项字段↗](http://yapi.cai-inc.com/project/3705/interface/api/547106) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/save-fee-item-field`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemSaveFeeItemFieldPost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemSaveFeeItemFieldPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemSaveFeeItemFieldPostResponse>(
    prepare(zlbCostControlBdFeeItemSaveFeeItemFieldPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemSaveFeeItemFieldPost.requestConfig =
  zlbCostControlBdFeeItemSaveFeeItemFieldPostRequestConfig;

/**
 * 接口 [费用项停启用↗](http://yapi.cai-inc.com/project/3705/interface/api/547114) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/change-fee-item-status`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemChangeFeeItemStatusPostRequest {
  /**
   * 费用项编码
   */
  feeItemCode: string;
  /**
   * 修改后的状态
   */
  status: string;
}

/**
 * 接口 [费用项停启用↗](http://yapi.cai-inc.com/project/3705/interface/api/547114) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/change-fee-item-status`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemChangeFeeItemStatusPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费用项停启用↗](http://yapi.cai-inc.com/project/3705/interface/api/547114) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/change-fee-item-status`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemChangeFeeItemStatusPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item/change-fee-item-status',
    'data',
    string,
    'feeItemCode' | 'status',
    false
  >
>;

/**
 * 接口 [费用项停启用↗](http://yapi.cai-inc.com/project/3705/interface/api/547114) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/change-fee-item-status`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemChangeFeeItemStatusPostRequestConfig: ZlbCostControlBdFeeItemChangeFeeItemStatusPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/zlb/cost/control/bd/fee-item/change-fee-item-status',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: ['feeItemCode', 'status'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemChangeFeeItemStatusPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费用项停启用↗](http://yapi.cai-inc.com/project/3705/interface/api/547114) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/change-fee-item-status`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemChangeFeeItemStatusPost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemChangeFeeItemStatusPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemChangeFeeItemStatusPostResponse>(
    prepare(zlbCostControlBdFeeItemChangeFeeItemStatusPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemChangeFeeItemStatusPost.requestConfig =
  zlbCostControlBdFeeItemChangeFeeItemStatusPostRequestConfig;

/**
 * 接口 [检测费用项是否已被单据引用,true已被引用，false未被引用。被引用的无法删除\/停用↗](http://yapi.cai-inc.com/project/3705/interface/api/547122) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/check-fee-item-referenced/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemCheckFeeItemReferencedFeeItemCodeGetRequest {
  feeItemCode: string;
}

/**
 * 接口 [检测费用项是否已被单据引用,true已被引用，false未被引用。被引用的无法删除\/停用↗](http://yapi.cai-inc.com/project/3705/interface/api/547122) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/check-fee-item-referenced/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemCheckFeeItemReferencedFeeItemCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [检测费用项是否已被单据引用,true已被引用，false未被引用。被引用的无法删除\/停用↗](http://yapi.cai-inc.com/project/3705/interface/api/547122) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/check-fee-item-referenced/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemCheckFeeItemReferencedFeeItemCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item/check-fee-item-referenced/{feeItemCode}',
    'data',
    'feeItemCode',
    string,
    false
  >
>;

/**
 * 接口 [检测费用项是否已被单据引用,true已被引用，false未被引用。被引用的无法删除\/停用↗](http://yapi.cai-inc.com/project/3705/interface/api/547122) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/check-fee-item-referenced/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemCheckFeeItemReferencedFeeItemCodeGetRequestConfig: ZlbCostControlBdFeeItemCheckFeeItemReferencedFeeItemCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/zlb/cost/control/bd/fee-item/check-fee-item-referenced/{feeItemCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: ['feeItemCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemCheckFeeItemReferencedFeeItemCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [检测费用项是否已被单据引用,true已被引用，false未被引用。被引用的无法删除\/停用↗](http://yapi.cai-inc.com/project/3705/interface/api/547122) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/check-fee-item-referenced/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemCheckFeeItemReferencedFeeItemCodeGet = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemCheckFeeItemReferencedFeeItemCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemCheckFeeItemReferencedFeeItemCodeGetResponse>(
    prepare(zlbCostControlBdFeeItemCheckFeeItemReferencedFeeItemCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemCheckFeeItemReferencedFeeItemCodeGet.requestConfig =
  zlbCostControlBdFeeItemCheckFeeItemReferencedFeeItemCodeGetRequestConfig;

/**
 * 接口 [删除费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/547130) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/delete-fee-item/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemDeleteFeeItemFeeItemCodePostRequest {
  feeItemCode: string;
}

/**
 * 接口 [删除费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/547130) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/delete-fee-item/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemDeleteFeeItemFeeItemCodePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/547130) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/delete-fee-item/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemDeleteFeeItemFeeItemCodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item/delete-fee-item/{feeItemCode}',
    'data',
    'feeItemCode',
    string,
    false
  >
>;

/**
 * 接口 [删除费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/547130) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/delete-fee-item/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemDeleteFeeItemFeeItemCodePostRequestConfig: ZlbCostControlBdFeeItemDeleteFeeItemFeeItemCodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/zlb/cost/control/bd/fee-item/delete-fee-item/{feeItemCode}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: ['feeItemCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemDeleteFeeItemFeeItemCodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/547130) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `POST /zlb/cost/control/bd/fee-item/delete-fee-item/{feeItemCode}`
 * @更新时间 `2023-10-10 17:52:58`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemDeleteFeeItemFeeItemCodePost = /*#__PURE__*/ (
  requestData: ZlbCostControlBdFeeItemDeleteFeeItemFeeItemCodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemDeleteFeeItemFeeItemCodePostResponse>(
    prepare(zlbCostControlBdFeeItemDeleteFeeItemFeeItemCodePostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemDeleteFeeItemFeeItemCodePost.requestConfig =
  zlbCostControlBdFeeItemDeleteFeeItemFeeItemCodePostRequestConfig;

/**
 * 接口 [获取全量字段可选项↗](http://yapi.cai-inc.com/project/3705/interface/api/547138) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/field-optional`
 * @更新时间 `2023-10-10 17:52:59`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemFieldOptionalGetRequest {}

/**
 * 接口 [获取全量字段可选项↗](http://yapi.cai-inc.com/project/3705/interface/api/547138) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/field-optional`
 * @更新时间 `2023-10-10 17:52:59`
 * @项目ID 3705
 */
export interface ZlbCostControlBdFeeItemFieldOptionalGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    fieldCode?: string;
    optionalList?: {
      /**
       * code
       */
      code?: string;
      /**
       * desc
       */
      desc?: string;
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取全量字段可选项↗](http://yapi.cai-inc.com/project/3705/interface/api/547138) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/field-optional`
 * @更新时间 `2023-10-10 17:52:59`
 * @项目ID 3705
 */
type ZlbCostControlBdFeeItemFieldOptionalGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/bd/fee-item/field-optional',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取全量字段可选项↗](http://yapi.cai-inc.com/project/3705/interface/api/547138) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/field-optional`
 * @更新时间 `2023-10-10 17:52:59`
 * @项目ID 3705
 */
const zlbCostControlBdFeeItemFieldOptionalGetRequestConfig: ZlbCostControlBdFeeItemFieldOptionalGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/zlb/cost/control/bd/fee-item/field-optional',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlBdFeeItemFieldOptionalGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取全量字段可选项↗](http://yapi.cai-inc.com/project/3705/interface/api/547138) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [百搭费用项↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53431)
 * @请求头 `GET /zlb/cost/control/bd/fee-item/field-optional`
 * @更新时间 `2023-10-10 17:52:59`
 * @项目ID 3705
 */
export const zlbCostControlBdFeeItemFieldOptionalGet = /*#__PURE__*/ (
  requestData?: ZlbCostControlBdFeeItemFieldOptionalGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlBdFeeItemFieldOptionalGetResponse>(
    prepare(zlbCostControlBdFeeItemFieldOptionalGetRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlBdFeeItemFieldOptionalGet.requestConfig =
  zlbCostControlBdFeeItemFieldOptionalGetRequestConfig;

const mockUrl_0_0_0_6 = 'http://yapi.cai-inc.com/mock/3705' as any;
const devUrl_0_0_0_6 = '' as any;
const prodUrl_0_0_0_6 = '' as any;
const dataKey_0_0_0_6 = 'data' as any;

/**
 * 接口 [查询差旅费控规则标准↗](http://yapi.cai-inc.com/project/3705/interface/api/557586) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [差旅费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53621)
 * @请求头 `POST /zlb/cost/control/travel/standard/info`
 * @更新时间 `2023-11-08 11:04:45`
 * @项目ID 3705
 */
export interface ZlbCostControlTravelStandardInfoPostRequest {
  /**
   * 标准类型
   */
  standardType: 1 | 2 | 3;
  /**
   * 交通标准
   */
  trafficQueryPO?: {
    /**
     * 目的地，选填
     */
    destination?: {
      /**
       * 一级区划
       */
      firstArea?: string;
      /**
       * 二级区划
       */
      secondArea?: string;
      /**
       * 三级区划
       */
      thirdArea?: string;
    };
    /**
     * 出发地，选填
     */
    departure?: {
      /**
       * 一级区划
       */
      firstArea?: string;
      /**
       * 二级区划
       */
      secondArea?: string;
      /**
       * 三级区划
       */
      thirdArea?: string;
    };
  };
  /**
   * 住宿标准
   */
  hotelQueryPO?: {
    /**
     * 目的地，必填
     */
    destination?: {
      /**
       * 一级区划
       */
      firstArea?: string;
      /**
       * 二级区划
       */
      secondArea?: string;
      /**
       * 三级区划
       */
      thirdArea?: string;
    };
  };
  /**
   * 补贴标准
   */
  allowanceQueryPO?: {
    /**
     * 出差类型,默认为普通出差
     */
    type?: 0 | 1 | 3;
    /**
     * 目的地，必填
     */
    destination?: {
      /**
       * 一级区划
       */
      firstArea?: string;
      /**
       * 二级区划
       */
      secondArea?: string;
      /**
       * 三级区划
       */
      thirdArea?: string;
    };
    /**
     * 出发地，选填
     */
    departure?: {
      /**
       * 一级区划
       */
      firstArea?: string;
      /**
       * 二级区划
       */
      secondArea?: string;
      /**
       * 三级区划
       */
      thirdArea?: string;
    };
  };
}

/**
 * 接口 [查询差旅费控规则标准↗](http://yapi.cai-inc.com/project/3705/interface/api/557586) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [差旅费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53621)
 * @请求头 `POST /zlb/cost/control/travel/standard/info`
 * @更新时间 `2023-11-08 11:04:45`
 * @项目ID 3705
 */
export interface ZlbCostControlTravelStandardInfoPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 标准类型
     */
    travelStandardType?: number;
    /**
     * 交通标准
     */
    trafficStandardRO?: {
      /**
       * 飞机
       */
      plane?: string;
      /**
       * 火车
       */
      train?: string;
      /**
       * 轮船
       */
      ship?: string;
      /**
       * 短途包干
       */
      shortDistanceRO?: {
        /**
         * 出发地
         */
        departure?: string;
        /**
         * 目的地
         */
        destination?: string;
        /**
         * 标准
         */
        amount?: number;
      };
    };
    /**
     * 住宿标准
     */
    hotelStandardRO?: {
      hotelStandardItemList?: {
        /**
         * 目的地
         */
        place?: string;
        /**
         * 开始时间，只取月日
         */
        start?: string;
        /**
         * 结束时间，只取月日
         */
        end?: string;
        /**
         * 金额
         */
        amount?: number;
      }[];
    };
    /**
     * 补贴标准
     */
    allowanceRO?: {
      /**
       * 出差类型
       */
      type?: 0 | 1 | 3;
      /**
       * 伙食补贴
       */
      foodAllowanceList?: {
        /**
         * 出发地
         */
        departureList?: string[];
        /**
         * 出发地地址，前端忽略
         */
        departureDTOList?: {
          /**
           * 一级区划
           */
          firstArea?: string;
          /**
           * 二级区划
           */
          secondArea?: string;
          /**
           * 三级区划
           */
          thirdArea?: string;
        }[];
        /**
         * 目的地
         */
        destination?: string;
        /**
         * 标准
         */
        standardList?: {
          /**
           * 费用标准
           */
          amount?: number;
          /**
           * 开始天数
           */
          startDay?: number;
          /**
           * 结束天数
           */
          endDay?: number;
        }[];
        /**
         * 是否凭票报销
         */
        invoice?: boolean;
      }[];
      /**
       * 普通出差，会议培训公杂补贴
       */
      miscellaneousAllowanceList?: {
        /**
         * 出发地
         */
        departureList?: string[];
        /**
         * 出发地，前端忽略
         */
        departureDTOList?: {
          /**
           * 一级区划
           */
          firstArea?: string;
          /**
           * 二级区划
           */
          secondArea?: string;
          /**
           * 三级区划
           */
          thirdArea?: string;
        }[];
        /**
         * 目的地
         */
        destination?: string;
        /**
         * 标准
         */
        standardList?: {
          /**
           * 派车金额
           */
          sendCar?: number;
          /**
           * 不派车金额
           */
          notSendCar?: number;
          /**
           * 开始天数
           */
          startDay?: number;
          /**
           * 结束天数
           */
          endDay?: number;
        }[];
      }[];
      /**
       * 外派公杂补贴
       */
      expatriateAllowanceList?: {
        /**
         * 目的地
         */
        destination?: string;
        /**
         * 每月补贴次数
         */
        allowanceTimes?: number;
        /**
         * 补贴标准
         */
        amount?: number;
        /**
         * 残月配置
         */
        lessThenOneMonthConfigList?: {
          /**
           * 残月补贴次数
           */
          times?: number;
          /**
           * 开始天数
           */
          startDay?: number;
          /**
           * 结束天数
           */
          endDay?: number;
        }[];
      }[];
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询差旅费控规则标准↗](http://yapi.cai-inc.com/project/3705/interface/api/557586) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [差旅费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53621)
 * @请求头 `POST /zlb/cost/control/travel/standard/info`
 * @更新时间 `2023-11-08 11:04:45`
 * @项目ID 3705
 */
type ZlbCostControlTravelStandardInfoPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3705',
    '',
    '',
    '/zlb/cost/control/travel/standard/info',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询差旅费控规则标准↗](http://yapi.cai-inc.com/project/3705/interface/api/557586) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [差旅费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53621)
 * @请求头 `POST /zlb/cost/control/travel/standard/info`
 * @更新时间 `2023-11-08 11:04:45`
 * @项目ID 3705
 */
const zlbCostControlTravelStandardInfoPostRequestConfig: ZlbCostControlTravelStandardInfoPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_6,
    devUrl: devUrl_0_0_0_6,
    prodUrl: prodUrl_0_0_0_6,
    path: '/zlb/cost/control/travel/standard/info',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbCostControlTravelStandardInfoPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询差旅费控规则标准↗](http://yapi.cai-inc.com/project/3705/interface/api/557586) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [差旅费用标准↗](http://yapi.cai-inc.com/project/3705/interface/api/cat_53621)
 * @请求头 `POST /zlb/cost/control/travel/standard/info`
 * @更新时间 `2023-11-08 11:04:45`
 * @项目ID 3705
 */
export const zlbCostControlTravelStandardInfoPost = /*#__PURE__*/ (
  requestData: ZlbCostControlTravelStandardInfoPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbCostControlTravelStandardInfoPostResponse>(
    prepare(zlbCostControlTravelStandardInfoPostRequestConfig, requestData),
    ...args,
  );
};

zlbCostControlTravelStandardInfoPost.requestConfig =
  zlbCostControlTravelStandardInfoPostRequestConfig;

/* prettier-ignore-end */
